import React, { Component } from 'react';
import Modal from 'react-modal';
import Select from 'react-select';
import ReactDOM from 'react-dom';
import Spreadsheet from "react-spreadsheet";
import '../assets/teachers.css';
import {Tooltip, Popover, OverlayTrigger, Overlay} from 'react-bootstrap';
import REST from '../Shared/REST';
import {OutTable, ExcelRenderer} from 'react-excel-renderer';
import XLSX from 'xlsx';
import HeaderComponent from '../Shared/Header';
import { withRouter, Redirect } from 'react-router-dom';
import ico_view from "../assets/images/ico_view.png";
import ico_plus_green from "../assets/images/ico_plus_green.png";
import ico_x from "../assets/images/modal_x_red.png";
import icon_finished from "../assets/images/correct-mark.png";
import icon_unfinished from "../assets/images/error-mark.png";
import icon_monty from "../assets/images/monty.png";
import icon_knowledge_bronze from "../assets/images/badges/knowledge-bronze.png";
import icon_knowledge_silver from "../assets/images/badges/knowledge-silver.png";
import icon_knowledge_gold from "../assets/images/badges/knowledge-gold.png";
import icon_knowledge_diamond from "../assets/images/badges/knowledge-diamond.png";
import icon_MainIdea_bronze from "../assets/images/badges/MainIdea-bronze.png";
import icon_MainIdea_silver from "../assets/images/badges/MainIdea-silver.png";
import icon_MainIdea_gold from "../assets/images/badges/MainIdea-gold.png";
import icon_MainIdea_diamond from "../assets/images/badges/MainIdea-diamond.png";
import icon_monitoring_bronze from "../assets/images/badges/monitoring-bronze.png";
import icon_monitoring_silver from "../assets/images/badges/monitoring-silver.png";
import icon_monitoring_gold from "../assets/images/badges/monitoring-gold.png";
import icon_monitoring_diamond from "../assets/images/badges/monitoring-diamond.png";
import icon_MomentOfTruth_bronze from "../assets/images/badges/moment-of-truth-bronze.png";
import icon_MomentOfTruth_silver from "../assets/images/badges/moment-of-truth-silver.png";
import icon_MomentOfTruth_gold from "../assets/images/badges/moment-of-truth-gold.png";
import icon_MomentOfTruth_diamond from "../assets/images/badges/moment-of-truth-diamond.png";
import icon_down_button from "../assets/images/down-button.png";
import icon_up_button from "../assets/images/up-button.png";
import icon_teacher_cici from "../assets/images/teacher/cici.png";
import icon_teacher_rincho from "../assets/images/teacher/rincho.png";
import icon_teacher_monkey from "../assets/images/teacher/monkey.png";
import icon_teacher_didi from "../assets/images/teacher/didi.png";
import icon_teacher_giraffe from "../assets/images/teacher/giraffe.png";
import icon_teacher_doug from "../assets/images/teacher/doug.png";
import icon_teacher_myla from "../assets/images/teacher/myla.png";


import Helpers from "../Shared/Helpers";
import {connect} from "react-redux";
import {
    selectClass,
    selectStudentScoreListTab,
    selectStudentTab,
    updateStudent,
    updateTeacher,
    userLogout
} from "./actions";
import EmailConsentForm from "../ModalFormComponents/EmailConsentForm";
import FooterComponent from "../Shared/Footer";
import DialogBox from "../Shared/DialogBox";
import TRACKING from "../Shared/DataTrackingPoints";

const tooltipDisability = (
    <Tooltip id="tooltipDisability">
        Multiple Select Option
    </Tooltip>
);
let tooltipSelectClass = (
    <Tooltip id="tooltipDisability">
        Select a class to view students
    </Tooltip>
);
const popoverAddClass = (
    <Popover id="popover-positioned-top" title="Step 1">
        Add a Class
    </Popover>
);
const popoverAddStudent = (
    <Popover id="popover-positioned-top" title="Step 2">
        Add a Student(s)
    </Popover>
);

let addClassStorage = localStorage.getItem('addClass');
let addStudentStorage = localStorage.getItem('addStudent');
let notice1Storage = localStorage.getItem('notice1');
let notice2Storage = localStorage.getItem('notice2');
let notice3Storage = localStorage.getItem('notice3');

let addClassInstruction = null;
let addStudentInstruction = null;

const customStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '45%'
    }
};

const dayOptions = [
    { value: '1', label: 'Day 1' },
    { value: '2', label: 'Day 2' },
    { value: '3', label: 'Day 3' },
    { value: '4', label: 'Day 4' }
];

const readingLevelOptions = [
    { value: '0', label: 'Above grade level' },
    { value: '1', label: 'At grade level' },
    { value: '2', label: 'Below grade level' },
    { value: '3', label: 'Unknown' }
];

const genderOptions = [
    { value: '1', label: 'Female' },
    { value: '2', label: 'Male' },
    { value: '3', label: 'Other' }
];

const raceOptions = [
    { value: '1', label: 'American Indian' },
    { value: '2', label: 'Asian' },
    { value: '3', label: 'Black or African American' },
    { value: '4', label: 'Native Hawaiian or Other Pacific Islander' },
    { value: '5', label: 'Caucasian (Hispanic or Latino)' },
    { value: '6', label: 'Caucasian (Not Hispanic or Latino)' },
    { value: '7', label: 'Unkown' }
];

const gradeOptions = [

    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
    { value: '6', label: '6' },
    { value: '7', label: '7' },
    { value: '8', label: '8' },
    { value: '9', label: '9' },
    { value: '10', label: '10' },
    { value: '11', label: '11' },
    { value: '12', label: '12' },
    { value: 'Transition', label: 'Transition' },
    { value: 'College', label: 'College' }

];

const fourValueOptions = [
    { value: '0', label: 'No' },
    { value: '1', label: 'Yes' },
    { value: '2', label: 'Unknown' }

];

let participantGroupOptions = [
    {value: '1', label: 'Base group'},
    {value: '9', label: 'BaseG2: Skip Training Camp'},
    {value: '2', label: 'S1G1: No Training Camp'},
    {value: '3', label: 'S1G2: Training Camp'},
    {value: '4', label: 'S1G3: Training Camp with Prompts'},
    {value: '5', label: 'S2G1: Free Form Highlights'},
    {value: '6', label: 'S2G2: SRL Highlighting'},
    {value: '7', label: 'S3G1: Delayed Monitoring'},
    {value: '8', label: 'S3G2: Instant Monitoring'},
    {value: '10', label: 'S4G1: No Moment of Truth'},
    {value: '11', label: 'S5G1: Reduced Training Camp '},
    {value: '12', label: 'S6G1: No judgment '},
    {value: '13', label: 'S6G2: No feedback '},
    {value: '14', label: 'S6G3: Generic Feedback '},
    {value: '15', label: 'S6G4: Customized Feedback '},
    {value: '16', label: 'S7G1: No Training Camp & Instant Monitoring'}
];


let getValue = (opts, val) => opts.find(o => o.value === val);
let getFourValue = (opts, val) => {
    if (val === '-1') return null;
    else opts.find(o => o.value === val);
}

class MainTeacherComponent extends Component {

    constructor(props) {
        super(props);
        this.state = { classes: [],
            class: {},
            classStudents: [],
            student: {},
            addClass: false,
            showClass: false,
            showStudent: false,
            newStudent: false ,
            clickedClassId:-1,
            modalDialog: false,
            responseContent:'',
            showAddClassHint:true, showNotice:true, showNotice2: false, showNotice1: true, showNotice3: true,
            analytics: {
                type: null,
                metadata: null,
            }};
        this.handleAddClass = this.handleAddClass.bind(this);
        this.handleClassItemClick = this.handleClassItemClick.bind(this);
        this.handleDeleteStudent = this.handleDeleteStudent.bind(this);
        this.handleDeleteClass = this.handleDeleteClass.bind(this);
        this.handleToggleAddClassHint = this.handleToggleAddClassHint.bind(this);
        this.getTarget = this.getTarget.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
        this.handleCloseNotice1 = this.handleCloseNotice1.bind(this);
        this.handleCloseNotice2 = this.handleCloseNotice2.bind(this);
        this.handleCloseNotice3 = this.handleCloseNotice3.bind(this);
        this.handleShowAllNotice = this.handleShowAllNotice.bind(this);
        this.handleShowNotice1 = this.handleShowNotice1.bind(this);
        this.handleShowNotice2 = this.handleShowNotice2.bind(this);
        this.handleShowNotice3 = this.handleShowNotice3.bind(this);
    }

    async componentDidMount() {
        Helpers.authorize(this);
        this.listClasses();
        if(localStorage.getItem('addClass') === 'hide'){
            this.setState({showAddClassHint: false})
        }
        if(localStorage.getItem('notice1') === 'hide'){
            this.setState({showNotice1: false})
        }
        if(localStorage.getItem('notice2') === 'hide'){
            this.setState({showNotice2: false})
        }
        if(localStorage.getItem('notice3') === 'hide'){
            this.setState({showNotice3: false})
        }
        if(this.props.lastClass){
            this.handleClassItemClick(this.props.lastClass);
            if(this.props.lastStudent){
                this.handleStudentClick(this.props.lastStudent,this.props.lastClass.id)
            }
        }
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleCloseNotice1(){
        this.setState({showNotice1: false});
        localStorage.setItem('notice1', 'hide');
    }

    handleCloseNotice2(){
        this.setState({showNotice2: false});
        localStorage.setItem('notice2', 'hide');
    }

    handleCloseNotice3(){
        this.setState({showNotice3: false});
        localStorage.setItem('notice3', 'hide');
    }

    handleShowAllNotice(){
        this.setState({showNotice1: true});
        localStorage.setItem('notice1', 'show');
        //localStorage.setItem('notice2', 'show');
    }

    handleShowNotice1(){
        this.setState({showNotice1: true});
        localStorage.setItem('notice1', 'show');
    }

    handleShowNotice2(){
        this.setState({showNotice1: true});
        localStorage.setItem('notice2', 'show');
    }

    handleShowNotice3(){
        this.setState({showNotice1: true});
        localStorage.setItem('notice3', 'show');
    }

    handleToggleAddClassHint(){
        this.setState({ showAddClassHint: false});
    }
    getTarget() {
        return ReactDOM.findDOMNode(this.target);
    }

    handleAddClass() {
        this.setState({ showClass: false, showNotice:false, addClass: !this.state.addClass, showStudent: false, newStudent: false });
        this.handleToggleAddClassHint();
        localStorage.setItem('addClass', 'hide');
    }

    handleCancel = () => {
        this.setState({ showClass: false, addClass: false, showStudent: false, newStudent: false });
        this.props.selectClass(null);
        this.props.updateStudent(null);
    };

    handleNewClassCallback = (classObject) => {
        let classes = this.state.classes;
        classes.push(classObject);
        this.setState({ classes: classes });
        this.handleClassItemClick(classes[classes.length-1]);
        this.setState({
                analytics: {
                    type: TRACKING.TEACHER_ADDED_CLASS,
                    metadata: {classId: classObject.id, className: classObject.name},
                }
            },
            ()=>this.handleAnalytics())
    };

    handleDeleteStudent(student){
        REST.deleteStudent(student.userId,this.props.teacher.id, this.props.lastClass.id).then(res => {
            this.handleClassItemClick(this.props.lastClass);
            this.setState({
                    analytics: {
                        type: TRACKING.TEACHER_STUDENT_DELETE,
                        metadata: {userId: student.user.id, firstName: student.user.firstname, lastName: student.user.lastname},
                    }
                },
                ()=>this.handleAnalytics())
        });
    }

    handleDeleteClass(theclass){
        REST.deleteClass(theclass.id).then(async res => {
            await this.handleCancel();
            await this.listClasses();
        });
    }

    handleClassItemClick = (object) => {
        this.handleCancel();
        REST.listStudents(object.id).then((response) => {
            if (response.success) {
                let res = response.body;
                this.setState({ showClass: true, classStudents: res, class: object, newStudent: false, showNotice:false, showStudent: false, clickedClassId:object.id });
                this.props.selectClass(object);
                this.setState({
                        analytics: {
                            type: TRACKING.TEACHER_SELECT_CLASS,
                            metadata: {classId:object.id, className: object.name},
                        }
                    },
                    ()=>this.handleAnalytics())
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            console.log('Error', error.msg);
        });
    };

    handleLogout = () => {
        REST.logout().then(async (response) => {
            if (response.success) {
                this.props.callback({});
                if(localStorage.getItem('addClass') === 'hide'){
                    addClassInstruction = localStorage.getItem('addClass');
                }
                if(localStorage.getItem('addStudent') === 'hide'){
                    addStudentInstruction = localStorage.getItem('addStudent');
                }
                localStorage.removeItem('token');
                if(addClassInstruction !== null){
                    localStorage.setItem('addClass',addClassInstruction);
                }
                if(addStudentInstruction !== null){
                    localStorage.setItem('addStudent',addStudentInstruction);
                }
                await this.props.persistor.purge();
                await this.props.userLogout();
                this.props.history.push("/");
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            this.setState({
                modalDialog: true,
                responseContent:error.msg

            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
    };

    handleUpdateClass = (object) => {
        this.handleCancel();
        this.setState({
                analytics: {
                    type: TRACKING.TEACHER_UPDATED_CLASS,
                    metadata: {classId: object.id, className: object.name},
                }
            },
            ()=>this.handleAnalytics())
        this.setState({ classes: [] });
        this.listClasses();
    };

    handleStudentClick = (student, classId) => {
        this.props.handleStudentClick(student, classId);
        this.props.updateStudent(student);
        this.props.history.push('/teacher/student');
    };

    handleAddStudent = (classId) => {
        this.setState({ newStudent: true, showNotice:false, addClass: false, showClass: false });
    };

    listClasses() {
        REST.classList().then((response) => {
            if (response.success) {
                this.setState({ classes: response.body });
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            this.setState({
                modalDialog: true,
                responseContent:error.msg

            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
    }

    render() {
        const sharedProps = {
            container: this,
            target: this.getTarget,
            show: this.state.showAddClassHint
        };
        let researcher=false;
        if(this.props.schoolAdmin&&this.props.schoolAdmin.schooladmin.researcher){
            researcher = true;
        };
        if(this.props.teacher&&this.props.teacher.teacher&&this.props.teacher.teacher.researcher){
            researcher = true;
        };
        return (
            <div>
                <HeaderComponent logout={this.handleLogout} notifications bugReport students studentClick={this.handleStudentClick}/>
                <div className="section bgGrey">
                    <div className="container">
                        <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                        <div className="row">
                            <div className="col-md-3">
                                <div className={"row"}>
                                    <div className={'col-md-10'}>
                                        <h1 className="fl">My Classes</h1>
                                    </div>
                                    <div className={'col-md-2'}>
                                        <a ref={button => {
                                            this.target = button;
                                        }} className="fr">
                                            <img src={ico_plus_green}  onClick={this.handleAddClass} alt="Plus Icon" border="0" className="ico-xs ico-add" />
                                        </a>
                                        {
                                            addClassStorage !== 'hide' ?
                                                <Overlay {...sharedProps} placement="top">
                                                    <Popover id="popover-positioned-top" title="Step 1">
                                                        Add a Class
                                                    </Popover>
                                                </Overlay>
                                                :
                                                null
                                        }
                                    </div>
                                </div>
                                <div className="col-lg-12 solidBorder noPadding">
                                    <ClassListComponent
                                        classes={this.state.classes}
                                        handleItemClick={this.handleClassItemClick}
                                        clickedClassID={this.state.clickedClassId}
                                        deleteClass={this.handleDeleteClass}
                                    />
                                </div>
                            </div>
                            {
                                this.state.addClass ? (
                                        <div className="col-md-9 container navbar-container">
                                            <h1>Add Class</h1>
                                            <AddClassComponent edit={false} teacherId={this.props.teacher.teacher.id} cancelCallback={this.handleCancel} saveClassCallback={this.handleNewClassCallback} />
                                        </div>)
                                    :
                                    null
                            }
                            {
                                this.state.showClass ?
                                    <ClassNavigation
                                        teacherId={this.props.teacher.id}
                                        classId={this.state.class.id}
                                        samplingStrategyId={this.props.teacher.teacher.samplingStrategyId}
                                        class={this.state.class}
                                        students={this.state.classStudents}
                                        teacher={this.props.teacher}
                                        handleAddStudent={this.handleAddStudent}
                                        studentClick={this.handleStudentClick}
                                        updateClassCallback={this.handleUpdateClass}
                                        deleteStudent={this.handleDeleteStudent}
                                        handleClassItemClick={this.handleClassItemClick}
                                    />
                                    :
                                    null
                            }
                            {
                                this.state.showNotice ?
                                    <div id="popover-positioned-bottom" className="col-md-9 container navbar-container" title="Notice" >
                                        <div><h1>Notice</h1>{this.state.showNotice1?<div className={"showNotice"}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>:
                                            <div className={"showNotice"} onClick={this.handleShowAllNotice}>[show all]</div>
                                        }</div>
                                        {this.state.showNotice1?
                                            <div className={"noticeBox"} style={{marginTop:20}}>
                                                <div className={"noticeTitle"}>Welcome to MissionsWithMonty</div>
                                                <div className={"noticeClose"} onClick={this.handleCloseNotice1}><img className={"noticeCloseIcon"} src={ico_x}/></div>
                                                <div className={"noticeContent"}>
                                                    To add a student account, please click on a class at the left side first. Then click on the plus button at the right side.
                                                </div>
                                            </div>
                                            :null}
                                        {this.state.showNotice2?
                                            <div className={"noticeBox"} style={{marginTop:170}}>
                                                <div className={"noticeTitle"}>Picture Cards </div>
                                                <div className={"noticeClose"} onClick={this.handleCloseNotice2}><img className={"noticeCloseIcon"} src={ico_x}/></div>
                                                <div className={"noticeContent"}>
                                                    To add a parent account, enter a parent's email address in the Student Details page. The parent will receive account information and access to their student's data charts (but not the teacher notes). Look in the Resources tab on the login page for more details.
                                                </div>
                                            </div>
                                            :null}
                                    </div>
                                    :
                                    null
                            }
                            {
                                this.state.newStudent ?
                                    <AddStudent teacherId={this.props.teacher.id} class={this.state.class} classId={this.state.class.id} samplingStrategyId={this.props.teacher.teacher.samplingStrategyId} handleCancel={this.handleCancel} handleClassItemClick={this.handleClassItemClick} researcher={researcher} participantGroupOptions = {participantGroupOptions}/>
                                    :
                                    null
                            }
                        </div>
                    </div>
                </div>
                {this.props.teacher && !this.props.teacher.teacher.consent ?
                    <EmailConsentForm updateTeacher={this.props.updateTeacher} teacher={this.props.teacher}/>
                    : null
                }
                <FooterComponent/>
            </div>
        );
    }
}

export class ClassNavigation extends Component {
    constructor(props) {
        super(props);
        this.state = { class: this.props.class, listStudents: true , gamePerformance: false, importStudents: false};
        this.handleStudentsTab = this.handleStudentsTab.bind(this);
        this.handleClassTab = this.handleClassTab.bind(this);
        this.handlePerformanceTab = this.handlePerformanceTab.bind(this);
        this.handleImportStudentsTab = this.handleImportStudentsTab.bind(this);

    }

    handleStudentClick = (student, classId) => {
        this.props.studentClick(student, classId);
    }

    handleAddStudent = () => {
        this.props.handleAddStudent(this.state.class.id);
    }

    handleStudentsTab(event) {
        this.setState({ listStudents: true, gamePerformance:false,importStudents:false});
        event.preventDefault();
    }

    handleClassTab(event) {
        this.setState({ listStudents: false, gamePerformance:false, importStudents:false});
        // event.preventDefault();
    }

    handleImportStudentsTab(event) {
        this.setState({ listStudents: false, gamePerformance:false, importStudents:true});
        // event.preventDefault();
    }

    handlePerformanceTab(event) {
        this.setState({ listStudents: false, gamePerformance:true, importStudents:false});
        // event.preventDefault();
    }

    handleCancel = () => {
        this.setState({ listStudents: true });
    }

    handleUpdateClass = (object) => {
        this.props.updateClassCallback(object);
    }

    listStudents() {
        REST.listStudents(this.props.class.id).then((response) => {
            if (response.success) {
                this.setState({ students: response.body });
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            console.log('List students error', error);
            this.setState({
                modalDialog: true,
                responseContent:error.msg

            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
    }

    render() {
        return (
            <div className="col-md-9">
                {this.state.listStudents ?
                    (
                        <Students
                            handleClassTab={this.handleClassTab}
                            handleImportStudentsTab={this.handleImportStudentsTab}
                            handlePerformanceTab={this.handlePerformanceTab}
                            classId={this.state.class.id}
                            handleAddStudent={this.handleAddStudent}
                            students={this.props.students}
                            researcher={this.props.teacher&&this.props.teacher.teacher.researcher}
                            handleItemClick={this.handleStudentClick}
                            deleteStudent={this.props.deleteStudent}
                        />
                    ) :this.state.gamePerformance?
                        (
                            <div>
                                <ul className="nav nav-tabs">
                                    <li onClick={this.handleStudentsTab}><a data-toggle="tab">Students</a></li>
                                    <li className="active" onClick={this.handlePerformanceTab}><a data-toggle="tab">Game Performance</a></li>
                                    <li onClick={this.handleClassTab}><a data-toggle="tab">Class Info</a></li>
                                    <li onClick={this.handleImportStudentsTab}><a data-toggle="tab">Import Students</a></li>
                                </ul>
                                <div className="tab-content" style={{width:825}}>
                                    <GamePerformaceComponent  class={this.state.class} cancelCallback={this.handleCancel}  />
                                </div>
                            </div>

                        ): this.state.importStudents?
                            (
                                <div>
                                    <ul className="nav nav-tabs">
                                        <li onClick={this.handleStudentsTab}><a data-toggle="tab">Students</a></li>
                                        <li onClick={this.handlePerformanceTab}><a data-toggle="tab">Game Performance</a></li>
                                        <li onClick={this.handleClassTab}><a data-toggle="tab">Class Info</a></li>
                                        <li className="active" onClick={this.handleImportStudentsTab}><a data-toggle="tab">Import Students</a></li>
                                    </ul>
                                    <div className="tab-content">
                                        <ImportStudentsComponent
                                            teacherId={this.props.teacher.id}
                                            class={this.state.class}
                                            classId={this.state.class.id}
                                            samplingStrategyId={this.props.teacher.teacher.samplingStrategyId}
                                            handleClassItemClick={this.props.handleClassItemClick}
                                        />
                                    </div>
                                </div>
                            ):
                            (
                                <div>
                                    <ul className="nav nav-tabs">
                                        <li onClick={this.handleStudentsTab}><a data-toggle="tab">Students</a></li>
                                        <li onClick={this.handlePerformanceTab}><a data-toggle="tab">Game Performance</a></li>
                                        <li className="active" onClick={this.handleClassTab}><a data-toggle="tab">Class Info</a></li>
                                        <li onClick={this.handleImportStudentsTab}><a data-toggle="tab">Import Students</a></li>
                                    </ul>
                                    <div className="tab-content">
                                        <AddClassComponent edit={true} teacherId={this.props.teacher.teacher.id} class={this.state.class} cancelCallback={this.handleCancel} saveClassCallback={this.handleUpdateClass} />
                                    </div>
                                </div>
                            )
                }
            </div>
        );
    }
}

class ImportStudentsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage:"",
            modalDialog: false,
            studentsData:[
                [{ value: "First Name" }, { value: "Last Name" }, { value: "User Name" }, { value: "Password" }, { value: "Email" }
                    , { value: "Gender" }, { value: "Race and Ethnicity" }, { value: "Grade Placement" }, { value: "Reading Level" }
                    , { value: "Research Group" }, { value: "IEP" }, { value: "ELL" }, { value: "Title 1" }
                    , { value: "FARMS" }],
                [{ value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }],
                [{ value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }],
                [{ value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }],
                [{ value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }],
            ],};
        this.handleImportStudentCancel = this.handleImportStudentCancel.bind(this);
        this.handleImportStudentSubmit = this.handleImportStudentSubmit.bind(this);
        this.handleImportStudentDownload = this.handleImportStudentDownload.bind(this);
        this.handleImportStudentDownloadTemplate = this.handleImportStudentDownloadTemplate.bind(this);
        this.validateStudentInfo = this.validateStudentInfo.bind(this);
    }

    fileHandler = (event) => {
        let fileObj = event.target.files[0];
        let studentInfoArr=[];
        //just pass the fileObj as parameter
        ExcelRenderer(fileObj, (err, resp) => {
            if(err){
                console.log(err);
            }
            else{

                resp.rows.forEach(function (d) {
                    let studentInfo = [];
                    let empty = true;
                    for (let i=0; i<=12;i++) {
                        studentInfo[i] = {value: d[i]};
                        if(d[i]){
                            empty = false;
                        }
                    }
                    if(!empty){
                        studentInfoArr.push(studentInfo);
                    }
                    console.log(studentInfo);
                });
                console.log("studentInfoArr");
                console.log(studentInfoArr);
                this.setState({studentsData:studentInfoArr});

            }
            console.log("resp");
            console.log(resp);
        });

    }

    handleImportStudentCancel= () => {
        this.setState({ studentsData:[[{ value: "First Name" }, { value: "Last Name" }, { value: "User Name" }, { value: "Password" }, { value: "Email" }
                , { value: "Gender" }, { value: "Race and Ethnicity" }, { value: "Grade Placement" }, { value: "Reading Level" }
                , { value: "Research Group" }, { value: "IEP" }, { value: "ELL" }, { value: "Title 1" }
                , { value: "FARMS" }],[],[],[],[],[],[]]});
    }
    validateStudentInfo(){
        let studentData = this.state.studentsData;
        let validation = true;
        this.state.studentsData.forEach((s) => {

            console.log("s");
            console.log(s);

            if(!s[0].value){//FirstName
                validation = false;
                this.setState({ errorMessage:'FirstName is empty.' , modalDialog: true});
            }
            if(!s[1].value){//LastName
                validation = false;
                this.setState({ errorMessage:'LastName is empty.', modalDialog: true });
            }
            if(!s[2].value){//UserName
                validation = false;
                this.setState({ errorMessage:'UserName is empty.' , modalDialog: true});
            }
            if(!s[3].value){//Password
                validation = false;
                this.setState({ errorMessage:'Password is empty.', modalDialog: true });
            }
        });
        return validation;
    }

    async handleImportStudentSubmit (){
        let valid = this.validateStudentInfo();
        if(!this.state.saved) {
            await this.setState({saved:true});
            if (valid) {
                this.setState({errorNote: ''});
                console.log("this.props.teacherId");
                console.log(this.props.teacherId);
                console.log("this.props.classId");
                console.log(this.props.classId);
                console.log("this.props.samplingStrategyId");
                console.log(this.props.samplingStrategyId);
                console.log("this.state.participantGroupId");
                console.log(this.state.participantGroupId);

                let studentsData = [];
                let i=0;
                this.state.studentsData.forEach((s) => {
                    if(i!==0) {
                        let studentData = {
                            firstname: s[0].value,
                            lastname: s[1].value,
                            username: s[2].value,
                            password: s[3].value,
                            email: s[4].value,
                        }
                        studentsData.push(studentData);
                    }
                    i++;
                });

                REST.addNewStudents(this.props.teacherId, this.props.classId, this.props.samplingStrategyId, this.state.participantGroupId, studentsData).then(async (response) => {
                    if (response.body.students && response.body.students[0]) {
                        this.setState({
                                saved:false,
                                analytics: {
                                    type: TRACKING.TEACHER_ADD_STUDENT,
                                    metadata: {
                                        userId: response.body.students[0].user.id,
                                        firstName: response.body.students[0].user.firstname,
                                        lastName: response.body.students[0].user.lastname
                                    },
                                }
                            });
                        this.handleCancel();
                    } else {
                        await this.setState({
                            saved: false,
                            modalDialog: true,
                            responseContent: 'Invalid data entered. The email account or username may have been used previously.'
                        });
                    }

                }, async (error) => {
                    await this.setState({
                        saved: false,
                        modalDialog: true,
                        responseContent: 'Error new student.'
                    });
                });

            } else {
                await this.setState({
                    errorNote: 'All fields not labeled "optional" are required!',
                    saved: false
                });
            }
        }
        console.log("valid");
        console.log(valid);

    }

    handleImportStudentDownload  ()  {


    }

    handleImportStudentDownloadTemplate = () => {


    }

    handleCancel(event) {
        //this.props.handleCancel();
        this.props.handleClassItemClick(this.props.class);
    }

    render()
    {
        return (
            <div>
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.errorMessage} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <div className={'"modal-footer"'} style={{width:820,overflow:'auto'}}>

                    <Spreadsheet  data={this.state.studentsData}/>

                </div>
                <div style={{marginTop:30}}>
                    <div style={{float:'left'}}>
                        <a onClick={this.handleImportStudentCancel} className="handBtn" target={"_blank"} href={"https://docs.google.com/document/d/1SveB2g_aCFci4YfhoeBHGqvqY5HnPywzdxiZCmM8X8E/edit"}><span>Instructions</span></a>

                    </div>
                    <div  style={{float:'right'}}>
                        <a  className="handBtn" href={"https://uploadmontybeta.s3.us-east-2.amazonaws.com/Documents/studentImport.xlsx"} download><span>Template</span></a>
                        <label className="custom-file-upload">
                            <input type="file" onChange={this.fileHandler.bind(this)} style={{"padding":"10px"}} />
                            <span>Import..</span>
                        </label>
                        <a onClick={this.handleImportStudentSubmit} className="handBtn"><span>Submit</span></a>
                        <a onClick={this.handleImportStudentCancel} className="handBtn"><span>Cancel</span></a>
                    </div>
                </div>

            </div>
        )

    }
}

class AddStudentComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saved: false,
            firstname: '',
            lastname: '',
            email: null,
            username: '',
            gender: null,
            race: null,
            language: null,
            disability: null,
            placement: null,
            gradeLevel: null,
            iep: '-1',
            freeLunch: '-1',
            ell: '-1',
            title1: '-1',
            farms: '-1',
            research: true,
            samplingStrategyId: this.props.samplingStrategyId,
            participantGroupId: null,
            screeningLevel: null,
            firstNameError: '',
            lastNameError: '',
            readingLevelError: '',
            genderError: '',
            raceError: '',
            languageError: '',
            disabilityError: '',
            placementError: '',
            gradeError: '',
            emailWarning: '',
            errorEmail: '',
            errorNote: '',
            apps:"picturenaming,wordsignsay,copyright,slash,kidsign,kidspeak,maze,wordmark",
            excludeVid:false,
            multipleValues: []
        };
        this.handleName = this.handleName.bind(this);
        this.handleLastName = this.handleLastName.bind(this);
        this.handlePassword = this.handlePassword.bind(this);
        this.handleUsername = this.handleUsername.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
        this.handleReadingLevel = this.handleReadingLevel.bind(this);
        this.handleGender = this.handleGender.bind(this);
        this.handleRace = this.handleRace.bind(this);
        this.handleFreeLunch = this.handleFreeLunch.bind(this);
        this.handleELL = this.handleELL.bind(this);
        this.handleIEP = this.handleIEP.bind(this);
        this.handleGrade = this.handleGrade.bind(this);
        this.handleTitle1 = this.handleTitle1.bind(this);
        this.handleFarms = this.handleFarms.bind(this);
        this.handleResearch = this.handleResearch.bind(this);
        // this.handleAppChange = this.handleAppChange.bind(this);

        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);

    }

    componentDidMount(){

    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleName(event) {
        this.setState({ firstname: event.target.value.trim() });
    }

    handleLastName(event) {
        this.setState({ lastname: event.target.value.trim() });
    }

    handleUsername(event) {
        this.setState({ username: event.target.value });
    }

    handlePassword(event) {
        this.setState({ password: event.target.value});
    }

    handleEmail(event) {
        this.setState({email: event.target.value});
        if(event.target.value.length === 0){
            this.setState({email: null, errorEmail: '', emailWarning: '' });
        }
        else {
            if (!this.validateEmail(event.target.value)){
                this.setState({errorEmail: 'validationRed', emailWarning: 'Email address format is invalid' });
            }
            else {
                this.setState({email: event.target.value, emailWarning: '', errorEmail: ''});
            }
        }
    }

    handleReadingLevel(event) {
        this.setState({ screeningLevel: event.value });
    }

    handleGender(event) {
        this.setState({ gender: event.value });
    }

    handleGrade(event) {
        this.setState({ gradeLevel: event.value });
    }

    handleRace(event) {
        this.setState({ race: event.value });
    }

    validateEmail(email) {
        let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    validate() {
        let valid = true;
        if (this.state.firstname === '') {
            valid = false;
            this.setState({ firstNameError:'' });
        }
        else {
            this.setState({ firstNameError:''});
        }
        if (this.state.lastname.length === 0){
            valid = false;
            this.setState({ lastNameError:'' });
        }
        else {
            this.setState({ lastNameError:'' });
        }
        if (this.state.username.length === 0){
            valid = false;
            this.setState({ userNameError:'userNameError' });
        }
        else {
            this.setState({ userNameError:'' });
        }
        if(!this.state.email || this.state.email === ''){
            this.setState({email: null, errorEmail: '', emailWarning: '' });
        }
        else {
            if (!this.validateEmail(this.state.email)){
                this.setState({errorEmail: 'validationRed', emailWarning: 'Email address format is invalid' });
                valid = false;
            }
            else {
                this.setState({emailWarning: '', errorEmail: ''});
            }
        }
        return valid;
    }

    handleELL(event) {
        this.setState({ ell: event === null ? '-1' : event.value });
    }

    handleFreeLunch(event) {
        this.setState({ freeLunch: event === null ? '-1' : event.value });
    }

    handleIEP(event) {
        this.setState({ iep: event === null ? '-1' : event.value });
    }

    handleTitle1(event) {
        this.setState({ title1: event === null ? '-1' : event.value });
    }

    handleFarms(event) {
        this.setState({ farms: event === null ? '-1' : event.value });
    }

    handleResearch(event) {
        this.setState({ research: !event.target.checked });
    }

    async handleSave(event) {
        if(!this.state.saved) {
            await this.setState({saved:true});
            if (this.validate()) {
                this.setState({errorNote: ''});

                REST.addNewStudent(this.props.teacherId, this.props.classId, this.props.samplingStrategyId, this.state.participantGroupId, this.state).then(async (response) => {
                    if (response.body.students && response.body.students[0]) {
                        this.setState({
                                saved:false,
                                analytics: {
                                    type: TRACKING.TEACHER_ADD_STUDENT,
                                    metadata: {
                                        userId: response.body.students[0].user.id,
                                        firstName: response.body.students[0].user.firstname,
                                        lastName: response.body.students[0].user.lastname
                                    },
                                }
                            },
                            () => this.handleAnalytics())
                        this.handleCancel();
                    } else {
                        await this.setState({
                            saved: false,
                            modalDialog: true,
                            responseContent: 'Invalid data entered. The email account or username may have been used previously.'
                        });
                    }

                }, async (error) => {
                    await this.setState({
                        saved: false,
                        modalDialog: true,
                        responseContent: 'Error new student.'
                    });
                });

            } else {
                await this.setState({
                    errorNote: 'All fields not labeled "optional" are required!',
                    saved: false
                });
            }
        }
    }

    handleCancel(event) {
        //this.props.handleCancel();
        this.props.handleClassItemClick(this.props.class);
    }

    render() {
        if (!this.props.classId) {
            return <Redirect to="/login" />
        }
        return (
            <div className="col-md-9">
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <h1>Add Student</h1>
                <div className="col-lg-12 solidBorder">
                    <div style={{color:'red',paddingLeft:15}}>{this.state.errorNote}</div>
                    <form id="formAddStudent">
                        <div className={"col-md-8 noPaddingLR15"}>
                            <div className="col-sm-6">
                                <label htmlFor="inputStudentName">First Name</label><br/>
                                <input type="text" value={this.state.firstName} onChange={this.handleName} id="inputStudentName" className={this.state.firstNameError + " form-control inputStyle1"} placeholder="First Name" required autoFocus />
                                <label htmlFor="inputStudentLastName">Last Name</label>
                                <input type="text" value={this.state.lastName} onChange={this.handleLastName} id="inputStudentLastName" className={this.state.lastNameError + " form-control inputStyle1"} placeholder="Last Name" required />
                                <label htmlFor="inputStudentUsername">User Name</label>
                                <input type="text" defaultValue={this.state.username} onChange={this.handleUsername} id="inputStudentUsername" maxLength="16" className="form-control inputStyle1" placeholder="User Name"/>
                                <label htmlFor="inputStudentPassword">Password</label>
                                <input type="text" defaultValue={this.state.password} onChange={this.handlePassword} id="inputStudentPassword" maxLength="16" className={this.state.passwordError + " form-control inputStyle1"} placeholder="Password" required />
                                <label htmlFor="inputStudentEmail">Email</label>
                                <input type="text" defaultValue={this.state.email} onChange={this.handleEmail} id="inputStudentEmail" className={this.state.errorEmail + ' form-control inputStyle1'} placeholder="Email" />
                            </div>
                            <div className="col-sm-6">
                                <label htmlFor="inputStudentGender">Gender</label>
                                <Select className={this.state.genderError}  onChange={this.handleGender} id="inputStudentGender" options={genderOptions} isSearchable={false} />
                                <label htmlFor="inputStudentRace">Race and Ethnicity</label>
                                <Select  onChange={this.handleRace} id="inputStudentRace"  defaultValue={getValue(raceOptions, this.state.race)} options={raceOptions} isSearchable={false} />
                                <label htmlFor="inputStudentGrade">Grade Placement</label>
                                <Select className={this.state.gradeError} onChange={this.handleGrade} id="inputStudentGrade" options={gradeOptions} isSearchable={false} />
                                <label htmlFor="inputStudentReadingLevel">Reading Level</label>
                                <Select className={this.state.readingLevelError}  onChange={this.handleReadingLevel} id="inputStudentReadingLevel"  options={readingLevelOptions} isSearchable={false} />
                                <div style={{color:'red'}}>{this.state.emailWarning}</div>
                                {this.props.researcher?
                                    <div>
                                        <label>Research Group</label>
                                        <div>
                                            <Select
                                                id={"updateParticipantGroup"}
                                                onChange={(newValue)=>{this.setState({ participantGroupId: newValue.value})}}
                                                options={this.props.participantGroupOptions}
                                                placeholder = {"Select a group..."}
                                                defaultValue={getValue(this.props.participantGroupOptions, this.state.participantGroupId)}
                                            />
                                        </div>
                                    </div>
                                    :null}
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <label htmlFor="inputStudentIEP">IEP (Optional)</label>
                            <Select  onChange={this.handleIEP} id="inputStudentIEP"  defaultValue={getFourValue(fourValueOptions, this.state.iep)} options={fourValueOptions} isSearchable={false} isClearable={true}/>
                            <label htmlFor="inputStudentELL">ELL (Optional)</label>
                            <Select  onChange={this.handleELL} id="inputStudentELL" defaultValue={getFourValue(fourValueOptions, this.state.ell)} options={fourValueOptions} isSearchable={false} isClearable={true}/>
                            <label htmlFor="inputStudentTitle1">Title 1 (Optional)</label>
                            <Select  onChange={this.handleTitle1} id="inputStudentTitle1"  defaultValue={getFourValue(fourValueOptions, this.state.title1)} options={fourValueOptions} isSearchable={false} isClearable={true}/>
                            <label htmlFor="inputFarms">FARMS (Optional)</label>
                            <Select  onChange={this.handleFarms} id="inputFarms"  defaultValue={getFourValue(fourValueOptions, this.state.farms)} options={fourValueOptions} isSearchable={false} isClearable={true}/><br/>
                            <label htmlFor="Research" className="cb"><input type="checkbox" onChange={this.handleResearch} name="Research" value={!this.state.research} id="Research" /><span className="checkmark"></span> Exclude Student Data</label>

                        </div>
                    </form>
                    <div className="clearfix"></div>
                    <div className="divBottomRelative tr">
                        {/*<p className="text-left">Note: Fields with * are required fields</p>*/}
                        {/*<hr />*/}
                        <a onClick={this.handleCancel} className="handBtn">
                            <span>Cancel</span>
                        </a>
                        <a onClick={() => { this.handleSave() } } className="handBtn">
                            <span>Save Changes</span>
                        </a>
                    </div>
                </div>
            </div >
        )
    }
}
const AddStudent = withRouter(AddStudentComponent);

class StudentsList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showAddStudentHint:true,
            analytics: {
                type: null,
                metadata: null,
            }}
        this.handleItemClick = this.handleItemClick.bind(this);
        this.handleClassTab = this.handleClassTab.bind(this);
        this.handleImportStudentsTab = this.handleImportStudentsTab.bind(this);
        this.handlePerformanceTab = this.handlePerformanceTab.bind(this);
        this.handleAddStudent = this.handleAddStudent.bind(this);
        this.handleAddStudentHint = this.handleAddStudentHint.bind(this);
        this.getTarget = this.getTarget.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
    }
    componentDidMount(){
        if(localStorage.getItem('addStudent') === 'hide'){
            this.setState({showAddStudentHint: false})
        }
    }
    handleAddStudentHint(){
        this.setState({showAddStudentHint: !this.state.showAddStudentHint})
    }
    getTarget() {
        return ReactDOM.findDOMNode(this.target);
    }

    handleClassTab(event) {
        this.props.handleClassTab();
    }

    handleImportStudentsTab(event) {
        this.props.handleImportStudentsTab();
    }

    handlePerformanceTab(event) {
        this.props.handlePerformanceTab();
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleItemClick = async (student) => {
        await this.setState({
                analytics:{
                    type:TRACKING.TEACHER_STUDENT_DETAILS_VIEW,
                    metadata:{userId: student.userId}
                }
            },
            () => {this.handleAnalytics();this.props.handleItemClick(student, this.props.classId);}  );
    };

    handleAddStudent(event) {
        this.props.handleAddStudent();
        this.handleAddStudentHint();
        localStorage.setItem('addStudent', 'hide');
        event.preventDefault();
    }

    render() {
        const sharedProps = {
            container: this,
            target: this.getTarget,
            show: this.state.showAddStudentHint
        };
        let items = this.props.students;
        let students = items.map((student) => {
            return <StudentListItem key={student.id} student={student} researcher={this.props.researcher} handleClick={this.handleItemClick} deleteStudent={this.props.deleteStudent}/>
        });
        return (
            <div>
                <a ref={button => {
                    this.target = button;
                }} className="fr">
                    <img src={ico_plus_green} onClick={this.handleAddStudent} style={{cursor:'pointer'}} alt="Plus Icon" border="0" className="ico-xs ico-add" />
                </a>
                {
                    addStudentStorage !== 'hide' ?
                        <Overlay {...sharedProps} placement="left">
                            <Popover id="popover-positioned-top" title="Step 2">
                                Add a Student(s)
                            </Popover>
                        </Overlay>
                        :
                        null
                }
                <ul className="nav nav-tabs">
                    <li className="active" onClick={this.handleStudentsTab}><a data-toggle="tab">Students</a></li>
                    <li onClick={this.handlePerformanceTab}><a data-toggle="tab">Game Performance</a></li>
                    <li onClick={this.handleClassTab}><a data-toggle="tab">Class Info</a></li>
                    <li onClick={this.handleImportStudentsTab}><a data-toggle="tab">Import Students</a></li>
                </ul>
                <div className="tab-pane active solidBorder noPadding">
                    <table cellPadding="0" cellSpacing="0" border="0" width="100%">
                        <thead>
                        <tr className="clickable-row">
                            <th className="fitWidth">#</th>
                            {this.props.researcher?null:<th>Full Name</th>}
                            <th >User Name</th>
                            {this.props.researcher?<th>Group</th>:null}
                            <th className="fitWidth">Password</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {students}
                        </tbody>
                    </table>
                </div>
            </div >
        );
    }
}
const Students = withRouter(StudentsList);

class StudentListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {modalDialog:false, responseContent:''}
        this.handleClick = this.handleClick.bind(this);
        this.deleteStudent = this.deleteStudent.bind(this);
    }

    handleClick(event) {
        this.props.handleClick(this.props.student);
        event.stopPropagation();
    }

    deleteStudent = (confirm) => {
        if(confirm) {
            this.props.deleteStudent(this.props.student);
        }
    }

    render() {
        let student = this.props.student;
        return (
            <tr className="clickable-row">
                <DialogBox
                    modalOpen={this.state.modalDialog}
                    confirmDelete={this.deleteStudent}
                    sectionContent={this.state.responseContent}
                    closeClick={(active)=>{this.setState({modalDialog: active});}}
                />
                <td onClick={(event)=>{this.setState({modalDialog:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS STUDENT?'});   event.stopPropagation();}}>
                    <input
                        style={{maxHeight:30}}
                        type="image"
                        alt={"Delete"}
                        src={require("../assets/images/ico-trash.png")}

                    />
                </td>
                {this.props.researcher?null:
                    <td onClick={this.handleClick}>{student.user.firstname} {student.user.lastname}</td>}
                <td onClick={this.handleClick}>{student.user.username}</td>
                {this.props.researcher?
                    <td onClick={this.handleClick}>{student.participant_group.name} </td>
                    :null}
                <td onClick={this.handleClick}>{student.user.password}</td>
                <td className="fitWidth" onClick={this.handleClick}>
                    <a>
                        <img src={ico_view} alt="View Icon" border="0" className="ico-xs" />
                    </a>
                </td>
            </tr>
        )
    }
}

class AddClassComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: this.props.class ? this.props.class.name : "", confirmDelete:false
        };
        this.handleName = this.handleName.bind(this);
        this.handleGrade = this.handleGrade.bind(this);
        this.handleSemester = this.handleSemester.bind(this);
        this.handleYear = this.handleYear.bind(this);

        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.deleteClass = this.deleteClass.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);

    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleName(event) {
        this.setState({ name: event.target.value });
    }

    handleGrade(event) {
        this.setState({ grade: event.target.value });
    }

    handleSemester(event) {
        this.setState({ semester: event.target.value });
    }

    handleYear(event) {
        this.setState({ year: event.target.value });
    }

    handleSave(event) {
        if (!this.state.name) {
            this.setState({
                modalDialog: true,
                responseContent:'Must enter class name'

            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
            return;
        }
        if (this.props.edit) {
            let body = { classId: this.props.class.id, name: this.state.name };
            REST.updateClass(this.props.teacherId,body).then((response) => {
                if (response.success) {
                    this.props.saveClassCallback(response.body);
                } else {
                    this.setState({
                        modalDialog: true,
                        responseContent:response.msg

                    });
                    setTimeout(()=>{this.setState({modalDialog:false})},3500);
                }
            }, (error) => {
                console.log('Add new class error', error);
                this.setState({
                    modalDialog: true,
                    responseContent:error.msg

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            });
        }
        else {
            let body = { name: this.state.name };
            REST.addNewClass(this.props.teacherId, body).then((response) => {
                if (response.success) {
                    this.props.saveClassCallback(response.body);
                } else {
                    this.setState({
                        modalDialog: true,
                        responseContent:response.msg

                    });
                    setTimeout(()=>{this.setState({modalDialog:false})},3500);
                }
            }, (error) => {
                console.log('Add new class error', error);
                this.setState({
                    modalDialog: true,
                    responseContent:error.msg

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            });
        }
        event.preventDefault();
    }

    handleCancel() {
        this.props.cancelCallback();
    }

    handleDelete() {
        REST.deleteClass(this.props.class.id).then((response) => {
            if (response.success) {
                this.setState({
                        analytics: {
                            type: TRACKING.TEACHER_DELETED_CLASS,
                            metadata: {classId: this.props.class.id},
                        }
                    },
                    ()=>this.handleAnalytics())
                this.props.saveClassCallback(response.body);
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg

                });

                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            console.log('Delete class error', error);
        });
    }

    deleteClass = (confirm) => {
        if(confirm){
            this.handleDelete();
        }
    }

    render() {
        return (
            <div className="col-lg-12 solidBorder hasfitWidth"><DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <form id="formAddClass">
                    <label htmlFor="inputClassName">Class Name</label>
                    <input type="text" onChange={this.handleName} id="inputClassName" value={this.state.name} className="form-control" placeholder="Class Name" required autoFocus />
                </form>
                <hr/>
                {!this.props.edit ?
                    (<div className="nav navbar fr">
                        <a onClick={this.handleCancel} className="handBtn">
                            <span>Cancel</span>
                        </a>
                        <a onClick={this.handleSave} className="handBtn">
                            <span>Save Changes</span>
                        </a>
                    </div>) :
                    (<div className="nav navbar fr">
                        <DialogBox
                            modalOpen={this.state.modalDialog}
                            confirmDelete={this.deleteClass}
                            sectionContent={this.state.responseContent}
                            closeClick={(active)=>{this.setState({modalDialog: active});}}
                        />
                        <a onClick={()=>{this.setState({modalDialog:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS CLASS?'})}} className="handBtn fl">
                            <span>Delete Class</span>
                        </a>
                        <a onClick={this.handleCancel} className="handBtn">
                            <span>Cancel</span>
                        </a>
                        <a onClick={this.handleSave} className="handBtn">
                            <span>Save Changes</span>
                        </a>
                    </div>)}

            </div>
        );
    }
}
export class GamePerformaceComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: this.props.class ? this.props.class.name : "", confirmDelete:false,

            classKnowledge: 0,
            classMonitoring: 0,
            classMainIdea: 0,
            classMomentOfTruth: 0,
            performanceList: [],

        };

        this.handleAnalytics = this.handleAnalytics.bind(this);

    }

    componentDidMount(){
        REST.listPerformance(this.props.class.id).then((response) => {
            if (response.success) {
                let performanceList = response.body;
                let knowledge_score=0,knowledge_max=0,monitoring_score=0,monitoring_max=0,mainIdea_score=0,mainIdea_max=0,momentOfTruth_score=0,momentOfTruth_max=0;
                let knowledge_null=0,monitoring_null=0,mainIdea_null=0,momentOfTruth_null=0;
                let knowledge_exist=0,monitoring_exist=0,mainIdea_exist=0,momentOfTruth_exist=0;
                let class_knowledge=0,class_monitoring=0,class_mainIdea=0,class_momentOfTruth=0;

                for (let i = 0; i < performanceList.length; i++) {
                    if(performanceList[i].progress&& performanceList[i].progress.progress_knowledge_score) {
                        Object.entries(performanceList[i].progress.progress_knowledge_score).forEach(([key,value]) => {
                            knowledge_score += value;
                        });
                        Object.entries(performanceList[i].progress.progress_knowledge_max).forEach(([key,value]) => {
                            knowledge_max += value;
                        });
                        knowledge_exist ++;
                    }else{
                        knowledge_null++;
                    } ;
                    if(performanceList[i].progress&& performanceList[i].progress.progress_monitoring_score) {
                        Object.entries(performanceList[i].progress.progress_monitoring_score).forEach(([key,value]) => {
                            monitoring_score += value;
                        });
                        Object.entries(performanceList[i].progress.progress_monitoring_max).forEach(([key,value]) => {
                            monitoring_max += value;
                        });
                        monitoring_exist ++;
                    }else{
                        monitoring_null ++;
                    };
                    if(performanceList[i].progress&& performanceList[i].progress.progress_mainIdea_score) {
                        Object.entries(performanceList[i].progress.progress_mainIdea_score).forEach(([key,value]) => {
                            mainIdea_score += value;
                        });
                        Object.entries(performanceList[i].progress.progress_mainIdea_max).forEach(([key,value]) => {
                            mainIdea_max += value;
                        });
                        mainIdea_exist ++;
                    }else{
                        mainIdea_null ++;
                    };
                    if(performanceList[i].progress&& performanceList[i].progress.progress_momentOfTruth_score) {
                        Object.entries(performanceList[i].progress.progress_momentOfTruth_score).forEach(([key,value]) => {
                            momentOfTruth_score += value;
                        });
                        Object.entries(performanceList[i].progress.progress_momentOfTruth_max).forEach(([key,value]) => {
                            momentOfTruth_max += value;
                        });
                        momentOfTruth_exist ++;
                    }else{
                        momentOfTruth_null ++;
                    }

                }
                if(knowledge_max!=0){
                    class_knowledge=((knowledge_score*knowledge_exist)/(knowledge_max*(knowledge_exist + knowledge_null))).toFixed(2);
                }
                if(monitoring_max!=0){
                    class_monitoring=((monitoring_score*monitoring_exist)/(monitoring_max*(monitoring_exist + monitoring_null))).toFixed(2);
                }
                if(mainIdea_max!=0){
                    class_mainIdea=((mainIdea_score*mainIdea_exist)/(mainIdea_max*(mainIdea_exist + mainIdea_null))).toFixed(2);
                }
                if(momentOfTruth_max!=0){
                    class_momentOfTruth=((momentOfTruth_score*momentOfTruth_exist)/(momentOfTruth_max*(momentOfTruth_exist + momentOfTruth_null))).toFixed(2);
                }
                this.setState({
                    performanceList: performanceList,
                    classKnowledge : class_knowledge,
                    classMonitoring : class_monitoring,
                    classMainIdea : class_mainIdea,
                    classMomentOfTruth : class_momentOfTruth,


                });
            }
            else {

            }
        }, (error) => {
            console.log('Error', error.msg);
        });
    }


    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    render() {
        let classKnowledgeWidth =  Math.round( Number(this.state.classKnowledge) * 100) + "%";
        let classMonitoringWidth = Math.round(Number(this.state.classMonitoring) * 100) + "%";
        let classMainIdeaWidth = Math.round(Number(this.state.classMainIdea) * 100) + "%";
        let classMomentOfTruthWidth = Math.round(Number(this.state.classMomentOfTruth) * 100) + "%";

        let performanceList = this.state.performanceList.map((studentPerformance) => {
            return <PerformanceListItemBrief role={this.props.role} performance={studentPerformance}/>
        });


        return (
            <div className="col-lg-12 solidBorder hasfitWidth"><DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <div style={{border:"solid", borderWidth: 1,padding: 20}}>
                    <div className={"row"}>
                        <div><h2> CLASS PROGRESS OVERVIEW </h2></div>

                        <hr/>
                        <div style={{marginTop: -10}}> <h3> SKILLS</h3> </div>
                        <div className={'progress-bar-block'} style={{marginTop: -5}}> knowledge </div>
                        <div className={'progress-stripes'} > </div>
                        {this.state.classKnowledge?
                            <div className={Math.round(this.state.classKnowledge * 100)<40? 'progress-gradient gradient-red':Math.round(this.state.classKnowledge * 100)<80?'progress-gradient gradient-yellow':'progress-gradient gradient-green'} style={{width:classKnowledgeWidth}}> {classKnowledgeWidth} </div> : <div className={' gradient-null'} style={{width:10}}>0%</div> }
                        <div className={'progress-bar-block clearfix'} style={{marginTop: -5}}> Monitoring </div>
                        <div className={'progress-stripes'} > </div>
                        {this.state.classMonitoring?
                            <div className={Math.round(this.state.classMonitoring * 100)<40? 'progress-gradient gradient-red':Math.round(this.state.classMonitoring * 100)<80?'progress-gradient gradient-yellow':'progress-gradient gradient-green'} style={{width:classMonitoringWidth }}> {classMonitoringWidth} </div> : <div className={' gradient-null'} style={{width:10}}>0%</div> }
                        <div className={'progress-bar-block clearfix'} style={{marginTop: -5}}> Main Idea </div>
                        <div className={'progress-stripes'} > </div>
                        {this.state.classMainIdea?
                            <div className={Math.round(this.state.classMainIdea * 100)<40? 'progress-gradient gradient-red':Math.round(this.state.classMainIdea * 100)<80?'progress-gradient gradient-yellow':'progress-gradient gradient-green'} style={{width:classMainIdeaWidth}}> {classMainIdeaWidth} </div> : <div className={' gradient-null'} style={{width:10}}>0%</div> }
                        <div className={'progress-bar-block clearfix'} style={{marginTop: -5, }}> Moment of Truth </div>
                        <div className={'progress-stripes'} > </div>
                        {this.state.classMomentOfTruth?
                            <div className={Math.round(this.state.classMomentOfTruth * 100)<40? 'progress-gradient gradient-red':Math.round(this.state.classMomentOfTruth * 100)<80?'progress-gradient gradient-yellow':'progress-gradient gradient-green'} style={{width:classMomentOfTruthWidth}}> {classMomentOfTruthWidth} </div> : <div className={' gradient-null'} style={{width:10}}>0%</div> }
                    </div>
                </div>
                {performanceList}
                <br/>
                <hr/>


            </div>
        );
    }
}

class PerformanceListItemBrief extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentBadge : this.props.performance && this.props.performance.badges && this.props.performance.badges[1]? this.props.performance.badges[1]: null ,
            isOpened: false,
            currentProgress : {
                knowledge : 0,
                monitoring : 0,
                mainIdea : 0,
                momentOfTruth: 0,
            },
            studentKnowledge : 0,
            studentMonitoring : 0,
            studentMainIdea : 0,
            studentMomentOfTruth : 0,
            currentDay: 1,
        }
        this.handleClick = this.handleClick.bind(this);
        this.handleBadgeChange = this.handleBadgeChange.bind(this);
        this.handleOpened = this.handleOpened.bind(this);
        this.handleClosed = this.handleClosed.bind(this);
        this.getCurrentProgress = this.getCurrentProgress.bind(this);
        this.getStudentPerformance = this.getStudentPerformance.bind(this);
    }
    getStudentPerformance(performance){
        console.log("0000");
        let student_knowledge_score=0,student_knowledge_max=0,student_monitoring_score=0,student_monitoring_max=0,student_mainIdea_score=0,student_mainIdea_max=0,student_momentOfTruth_score=0,student_momentOfTruth_max=0;
        let student_knowledge=0,student_monitoring=0,student_mainIdea=0,student_momentOfTruth=0;
        console.log("0001");
        Object.entries(performance.progress.progress_knowledge_score).forEach(([key,value]) => {
            student_knowledge_score += value;
        });

        Object.entries(performance.progress.progress_knowledge_max).forEach(([key,value]) => {
            student_knowledge_max += value;
        });
        Object.entries(performance.progress.progress_monitoring_score).forEach(([key,value]) => {
            student_monitoring_score += value;
        });
        Object.entries(performance.progress.progress_monitoring_max).forEach(([key,value]) => {
            student_monitoring_max += value;
        });
        Object.entries(performance.progress.progress_mainIdea_score).forEach(([key,value]) => {
            student_mainIdea_score += value;
        });
        Object.entries(performance.progress.progress_mainIdea_max).forEach(([key,value]) => {
            student_mainIdea_max += value;
        });
        Object.entries(performance.progress.progress_momentOfTruth_score).forEach(([key,value]) => {
            student_momentOfTruth_score += value;
        });
        Object.entries(performance.progress.progress_momentOfTruth_max).forEach(([key,value]) => {
            student_momentOfTruth_max += value;
        });

        if(student_knowledge_max!=0){
            student_knowledge=(student_knowledge_score/student_knowledge_max).toFixed(2);
        }
        if(student_monitoring_max!=0){
            student_monitoring=(student_monitoring_score/student_monitoring_max).toFixed(2);
        }
        if(student_mainIdea_max!=0){
            student_mainIdea=(student_mainIdea_score/student_mainIdea_max).toFixed(2);
        }
        if(student_momentOfTruth_max!=0){
            student_momentOfTruth=(student_momentOfTruth_score/student_momentOfTruth_max).toFixed(2);
        }
        console.log("student_knowledge");
        console.log(student_knowledge);
        console.log(student_monitoring);
        console.log(student_mainIdea);
        console.log(student_momentOfTruth);
        this.setState({
            studentKnowledge : student_knowledge,
            studentMonitoring : student_monitoring,
            studentMainIdea : student_mainIdea,
            studentMomentOfTruth : student_momentOfTruth,


        });

    }
    /*
    componentDidMount() {
        console.log("0002");
        this.getStudentPerformance(this.props.performance);
    }
    render() {
        let studentKnowledgeWidth =  Math.round( Number(this.state.studentKnowledge) * 100) + "%";
        let studentMonitoringWidth = Math.round(Number(this.state.studentMonitoring) * 100) + "%";
        let studentMainIdeaWidth = Math.round(Number(this.state.studentMainIdea) * 100) + "%";
        let studentMomentOfTruthWidth = Math.round(Number(this.state.studentMomentOfTruth) * 100) + "%";

        return (
            <div className="col-lg-12 solidBorder hasfitWidth"><DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <div style={{border:"solid", borderWidth: 1,padding: 20}}>
                    <div className={"row"}>
                        <div><h2> STUDENT PROGRESS OVERVIEW </h2></div>

                        <hr/>
                        <div style={{marginTop: -10}}> <h3> SKILLS</h3> </div>
                        <div className={'progress-bar-block'} style={{marginTop: -5}}> knowledge </div>
                        <div className={'progress-stripes'} > </div>
                        {this.state.studentKnowledge?
                            <div className={Math.round(this.state.studentKnowledge * 100)<40? 'progress-gradient gradient-red':Math.round(this.state.studentKnowledge * 100)<80?'progress-gradient gradient-yellow':'progress-gradient gradient-green'} style={{width:studentKnowledgeWidth}}> {studentKnowledgeWidth} </div> : <div className={' gradient-null'} style={{width:10}}>0%</div> }
                        <div className={'progress-bar-block clearfix'} style={{marginTop: -5}}> Monitoring </div>
                        <div className={'progress-stripes'} > </div>
                        {this.state.studentMonitoring?
                            <div className={Math.round(this.state.studentMonitoring * 100)<40? 'progress-gradient gradient-red':Math.round(this.state.studentMonitoring * 100)<80?'progress-gradient gradient-yellow':'progress-gradient gradient-green'} style={{width:studentMonitoringWidth }}> {studentMonitoringWidth} </div> : <div className={' gradient-null'} style={{width:10}}>0%</div> }
                        <div className={'progress-bar-block clearfix'} style={{marginTop: -5}}> Main Idea </div>
                        <div className={'progress-stripes'} > </div>
                        {this.state.studentMainIdea?
                            <div className={Math.round(this.state.studentMainIdea * 100)<40? 'progress-gradient gradient-red':Math.round(this.state.studentMainIdea * 100)<80?'progress-gradient gradient-yellow':'progress-gradient gradient-green'} style={{width:studentMainIdeaWidth}}> {studentMainIdeaWidth} </div> : <div className={' gradient-null'} style={{width:10}}>0%</div> }
                        <div className={'progress-bar-block clearfix'} style={{marginTop: -5, }}> Moment of Truth </div>
                        <div className={'progress-stripes'} > </div>
                        {this.state.studentMomentOfTruth?
                            <div className={Math.round(this.state.studentMomentOfTruth * 100)<40? 'progress-gradient gradient-red':Math.round(this.state.studentMomentOfTruth * 100)<80?'progress-gradient gradient-yellow':'progress-gradient gradient-green'} style={{width:studentMomentOfTruthWidth}}> {studentMomentOfTruthWidth} </div> : <div className={' gradient-null'} style={{width:10}}>0%</div> }
                    </div>
                </div>
                {performance}
                <br/>
                <hr/>


            </div>
        );
    }*/

    getCurrentProgress( progress, day, type){
        let value = 0;
        let score = 0;
        let maxScore = 0;
        if(day == 1 && type == "knowledge"){
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["1-1"]?  progress.progress_knowledge_score["1-1"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["1-2"]?  progress.progress_knowledge_score["1-2"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["1-3"]?  progress.progress_knowledge_score["1-3"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["1-4"]?  progress.progress_knowledge_score["1-4"]:0;

            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["1-1"]?  progress.progress_knowledge_max["1-1"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["1-2"]?  progress.progress_knowledge_max["1-2"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["1-3"]?  progress.progress_knowledge_max["1-3"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["1-4"]?  progress.progress_knowledge_max["1-4"]:0;
        }
        else if(day == 1 && type == "monitoring") {
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["1-1"] ? progress.progress_monitoring_score["1-1"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["1-2"] ? progress.progress_monitoring_score["1-2"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["1-3"] ? progress.progress_monitoring_score["1-3"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["1-4"] ? progress.progress_monitoring_score["1-4"] : 0;

            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["1-1"] ? progress.progress_monitoring_max["1-1"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["1-2"] ? progress.progress_monitoring_max["1-2"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["1-3"] ? progress.progress_monitoring_max["1-3"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["1-4"] ? progress.progress_monitoring_max["1-4"] : 0;
        }
        else if(day == 1 && type == "mainIdea") {
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["1-1"] ? progress.progress_mainIdea_score["1-1"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["1-2"] ? progress.progress_mainIdea_score["1-2"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["1-3"] ? progress.progress_mainIdea_score["1-3"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["1-4"] ? progress.progress_mainIdea_score["1-4"] : 0;

            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["1-1"] ? progress.progress_mainIdea_max["1-1"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["1-2"] ? progress.progress_mainIdea_max["1-2"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["1-3"] ? progress.progress_mainIdea_max["1-3"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["1-4"] ? progress.progress_mainIdea_max["1-4"] : 0;
        }
        else if(day == 1 && type == "momentOfTruth") {
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["1-1"] ? progress.progress_momentOfTruth_score["1-1"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["1-2"] ? progress.progress_momentOfTruth_score["1-2"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["1-3"] ? progress.progress_momentOfTruth_score["1-3"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["1-4"] ? progress.progress_momentOfTruth_score["1-4"] : 0;

            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["1-1"] ? progress.progress_momentOfTruth_max["1-1"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["1-2"] ? progress.progress_momentOfTruth_max["1-2"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["1-3"] ? progress.progress_momentOfTruth_max["1-3"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["1-4"] ? progress.progress_momentOfTruth_max["1-4"] : 0;
        }

        else if(day == 2 && type == "knowledge"){
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["2-5"]?  progress.progress_knowledge_score["2-5"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["2-6"]?  progress.progress_knowledge_score["2-6"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["2-7"]?  progress.progress_knowledge_score["2-7"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["2-8"]?  progress.progress_knowledge_score["2-8"]:0;

            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["2-5"]?  progress.progress_knowledge_max["2-5"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["2-6"]?  progress.progress_knowledge_max["2-6"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["2-7"]?  progress.progress_knowledge_max["2-7"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["2-8"]?  progress.progress_knowledge_max["2-8"]:0;
        }
        else if(day == 2 && type == "monitoring") {
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["2-5"] ? progress.progress_monitoring_score["2-5"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["2-6"] ? progress.progress_monitoring_score["2-6"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["2-7"] ? progress.progress_monitoring_score["2-7"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["2-8"] ? progress.progress_monitoring_score["2-8"] : 0;

            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["2-5"] ? progress.progress_monitoring_max["2-5"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["2-6"] ? progress.progress_monitoring_max["2-6"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["2-7"] ? progress.progress_monitoring_max["2-7"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["2-8"] ? progress.progress_monitoring_max["2-8"] : 0;
        }
        else if(day == 2 && type == "mainIdea") {
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["2-5"] ? progress.progress_mainIdea_score["2-5"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["2-6"] ? progress.progress_mainIdea_score["2-6"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["2-7"] ? progress.progress_mainIdea_score["2-7"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["2-8"] ? progress.progress_mainIdea_score["2-8"] : 0;

            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["2-5"] ? progress.progress_mainIdea_max["2-5"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["2-6"] ? progress.progress_mainIdea_max["2-6"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["2-7"] ? progress.progress_mainIdea_max["2-7"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["2-8"] ? progress.progress_mainIdea_max["2-8"] : 0;
        }
        else if(day == 2 && type == "momentOfTruth") {
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["2-5"] ? progress.progress_momentOfTruth_score["2-5"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["2-6"] ? progress.progress_momentOfTruth_score["2-6"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["2-7"] ? progress.progress_momentOfTruth_score["2-7"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["2-8"] ? progress.progress_momentOfTruth_score["2-8"] : 0;

            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["2-5"] ? progress.progress_momentOfTruth_max["2-5"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["2-6"] ? progress.progress_momentOfTruth_max["2-6"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["2-7"] ? progress.progress_momentOfTruth_max["2-7"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["2-8"] ? progress.progress_momentOfTruth_max["2-8"] : 0;
        }
        else if(day == 3 && type == "knowledge"){
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["3-9"]?  progress.progress_knowledge_score["3-9"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["3-10"]?  progress.progress_knowledge_score["3-10"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["3-11"]?  progress.progress_knowledge_score["3-11"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["3-12"]?  progress.progress_knowledge_score["3-12"]:0;

            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["3-9"]?  progress.progress_knowledge_max["3-9"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["3-10"]?  progress.progress_knowledge_max["3-10"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["3-11"]?  progress.progress_knowledge_max["3-11"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["3-12"]?  progress.progress_knowledge_max["3-12"]:0;
        }
        else if(day == 3 && type == "monitoring") {
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["3-9"] ? progress.progress_monitoring_score["3-9"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["3-10"] ? progress.progress_monitoring_score["3-10"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["3-11"] ? progress.progress_monitoring_score["3-11"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["3-12"] ? progress.progress_monitoring_score["3-12"] : 0;

            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["3-9"] ? progress.progress_monitoring_max["3-9"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["3-10"] ? progress.progress_monitoring_max["3-10"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["3-11"] ? progress.progress_monitoring_max["3-11"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["3-12"] ? progress.progress_monitoring_max["3-12"] : 0;
        }
        else if(day == 3 && type == "mainIdea") {
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["3-9"] ? progress.progress_mainIdea_score["3-9"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["3-10"] ? progress.progress_mainIdea_score["3-10"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["3-11"] ? progress.progress_mainIdea_score["3-11"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["3-12"] ? progress.progress_mainIdea_score["3-12"] : 0;

            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["3-9"] ? progress.progress_mainIdea_max["3-9"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["3-10"] ? progress.progress_mainIdea_max["3-10"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["3-11"] ? progress.progress_mainIdea_max["3-11"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["3-12"] ? progress.progress_mainIdea_max["3-12"] : 0;
        }
        else if(day == 3 && type == "momentOfTruth") {
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["3-9"] ? progress.progress_momentOfTruth_score["3-9"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["3-10"] ? progress.progress_momentOfTruth_score["3-10"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["3-11"] ? progress.progress_momentOfTruth_score["3-11"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["3-12"] ? progress.progress_momentOfTruth_score["3-12"] : 0;

            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["3-9"] ? progress.progress_momentOfTruth_max["3-9"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["3-10"] ? progress.progress_momentOfTruth_max["3-10"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["3-11"] ? progress.progress_momentOfTruth_max["3-11"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["3-12"] ? progress.progress_momentOfTruth_max["3-12"] : 0;
        }
        else if(day == 4 && type == "knowledge"){
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["4-13"]?  progress.progress_knowledge_score["4-13"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["4-14"]?  progress.progress_knowledge_score["4-14"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["4-15"]?  progress.progress_knowledge_score["4-15"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["4-16"]?  progress.progress_knowledge_score["4-16"]:0;

            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["4-13"]?  progress.progress_knowledge_max["4-13"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["4-14"]?  progress.progress_knowledge_max["4-14"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["4-15"]?  progress.progress_knowledge_max["4-15"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["4-16"]?  progress.progress_knowledge_max["4-16"]:0;
        }
        else if(day == 4 && type == "monitoring") {
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["4-13"] ? progress.progress_monitoring_score["4-13"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["4-14"] ? progress.progress_monitoring_score["4-14"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["4-15"] ? progress.progress_monitoring_score["4-15"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["4-16"] ? progress.progress_monitoring_score["4-16"] : 0;

            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["4-13"] ? progress.progress_monitoring_max["4-13"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["4-14"] ? progress.progress_monitoring_max["4-14"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["4-15"] ? progress.progress_monitoring_max["4-15"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["4-16"] ? progress.progress_monitoring_max["4-16"] : 0;
        }
        else if(day == 4 && type == "mainIdea") {
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["4-13"] ? progress.progress_mainIdea_score["4-13"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["4-14"] ? progress.progress_mainIdea_score["4-14"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["4-15"] ? progress.progress_mainIdea_score["4-15"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["4-16"] ? progress.progress_mainIdea_score["4-16"] : 0;

            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["4-13"] ? progress.progress_mainIdea_max["4-13"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["4-14"] ? progress.progress_mainIdea_max["4-14"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["4-15"] ? progress.progress_mainIdea_max["4-15"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["4-16"] ? progress.progress_mainIdea_max["4-16"] : 0;
        }
        else if(day == 4 && type == "momentOfTruth") {
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["4-13"] ? progress.progress_momentOfTruth_score["4-13"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["4-14"] ? progress.progress_momentOfTruth_score["4-14"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["4-15"] ? progress.progress_momentOfTruth_score["4-15"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["4-16"] ? progress.progress_momentOfTruth_score["4-16"] : 0;

            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["4-13"] ? progress.progress_momentOfTruth_max["4-13"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["4-14"] ? progress.progress_momentOfTruth_max["4-14"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["4-15"] ? progress.progress_momentOfTruth_max["4-15"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["4-16"] ? progress.progress_momentOfTruth_max["4-16"] : 0;
        }
        if(maxScore!=0){
            value = score/maxScore;
            value = value.toFixed(2);
        }
        return value;
    }
    componentDidMount(){

        console.log("0002");
        this.getStudentPerformance(this.props.performance);
        this.setState({
            currentBadge: this.props.performance && this.props.performance.badges && this.props.performance.badges[1]? this.props.performance.badges[1]: null,
            currentProgress: {
                knowledge : this.getCurrentProgress(this.props.performance.progress,this.state.currentDay,"knowledge"),
                monitoring : this.getCurrentProgress(this.props.performance.progress,this.state.currentDay,"monitoring"),
                mainIdea : this.getCurrentProgress(this.props.performance.progress,this.state.currentDay,"mainIdea"),
                momentOfTruth: this.getCurrentProgress(this.props.performance.progress,this.state.currentDay,"momentOfTruth"),
            }
        })
    }

    componentDidUpdate(oldProps){
        const newProps = this.props;
        if(oldProps.performance.id !== newProps.performance.id) {
            this.setState({
                currentBadge: this.props.performance && this.props.performance.badges && this.props.performance.badges[1] ? this.props.performance.badges[1] : null,
                currentProgress: {
                    knowledge : this.getCurrentProgress(this.props.performance.progress,this.state.currentDay,"knowledge"),
                    monitoring : this.getCurrentProgress(this.props.performance.progress,this.state.currentDay,"monitoring"),
                    mainIdea : this.getCurrentProgress(this.props.performance.progress,this.state.currentDay,"mainIdea"),
                    momentOfTruth: this.getCurrentProgress(this.props.performance.progress,this.state.currentDay,"momentOfTruth")
                }
            })
        }
    }
    handleOpened(event) {
        this.setState({isOpened : !this.state.isOpened});
    }
    handleClick(event) {
        this.props.handleClick(this.props.student);
        event.stopPropagation();
    }

    handleClosed() {

        this.setState({
            isOpened: false,
        });

    }
    async handleBadgeChange(event) {
        await this.setState({
            currentDay: event.value,
            currentBadge: this.props.performance.badges[event.value],
            currentProgress: {
                knowledge : this.getCurrentProgress(this.props.performance.progress,event.value,"knowledge"),
                monitoring : this.getCurrentProgress(this.props.performance.progress,event.value,"monitoring"),
                mainIdea : this.getCurrentProgress(this.props.performance.progress,event.value,"mainIdea"),
                momentOfTruth: this.getCurrentProgress(this.props.performance.progress,event.value,"momentOfTruth"),
            }
        })
    }


    render() {
        let student = this.props.student;
        let performance = this.props.performance;
        let dayNumber;
        let dayPassage;
        let siteStr ='';
        let dayWidth;
        let montyWidth;
        let montyPosition;
        let positionWidth;
        let isTrainingCamp = false;
        let trainingCampWidth="0%";
        let knowledgeWidth = "0%;"
        let monitoringWidth = "0%;";
        let mainIdeaWidth = "0%;";
        let momentOfTruthWidth = "0%;";
        let finishedSites;
        let knowledgeBadge = this.state.currentBadge && this.state.currentBadge.knowledge?this.state.currentBadge.knowledge: null;
        let monitoringBadge = this.state.currentBadge && this.state.currentBadge.monitoring?this.state.currentBadge.monitoring:null;
        let mainIdeaBadge = this.state.currentBadge && this.state.currentBadge.mainIdea?this.state.currentBadge.mainIdea:null;
        let momentOfTruthBadge = this.state.currentBadge && this.state.currentBadge.momentOfTruth?this.state.currentBadge.momentOfTruth:null;
        knowledgeBadge = knowledgeBadge ? knowledgeBadge.charAt(0).toUpperCase() +  knowledgeBadge.slice(1): null;
        monitoringBadge = monitoringBadge ? monitoringBadge.charAt(0).toUpperCase() +  monitoringBadge.slice(1): null;
        mainIdeaBadge = mainIdeaBadge ? mainIdeaBadge.charAt(0).toUpperCase() +  mainIdeaBadge.slice(1): null;
        momentOfTruthBadge = momentOfTruthBadge ? momentOfTruthBadge.charAt(0).toUpperCase() +  momentOfTruthBadge.slice(1): null;
        if(!performance.user.user_save){
            performance.user.user_save = {};
            performance.user.user_save.trainingCamp = "0";
            performance.user.user_save.dayTransition = "0";
        }

        knowledgeWidth =  (23 * this.state.currentProgress.knowledge) + "%";
        monitoringWidth = (23 * this.state.currentProgress.monitoring) + "%";
        mainIdeaWidth = (23 * this.state.currentProgress.mainIdea) + "%";
        momentOfTruthWidth = (23 * this.state.currentProgress.momentOfTruth) + "%";

        if(performance.user.user_save && performance.user.user_save.site){

            for(let i=0; i< 7; i++){

                if(performance.user.user_save.site.substring(i,i+1)=='1') {
                    siteStr = siteStr+(i+1)+', ' ;
                }
            }
            if(siteStr) {
                siteStr = siteStr.substring(0,siteStr.length - 2);

            }

        }

        if(!performance.user.user_save) {
            dayNumber = 0;
            dayPassage = 0;
            dayWidth = 0;
            isTrainingCamp = true;
            trainingCampWidth="2%";
        }else if(performance.user.user_save.trainingCamp < 5 && performance.user.user_save && performance.user.user_save.passage <= 1){
            dayNumber = 0;
            dayWidth = (17 * performance.user.user_save.trainingCamp /5)  + "%";
            trainingCampWidth="2%";
            isTrainingCamp = true;

        } else if ( performance.user.user_save.passage <= 2){
            dayNumber = 1;
            dayPassage =  performance.user.user_save.passage;
            dayWidth = (18 * (dayPassage-1) /4) + "%";
        } else if ( performance.user.user_save.passage === 3){
            dayNumber = 2;
            dayPassage =  performance.user.user_save.passage - 2;
            dayWidth = (18 * (dayPassage - 1)/4) + "%";
        } else if  ( performance.user.user_save.passage > 3 &&  performance.user.user_save.passage <= 6){
            dayNumber = 3;
            dayPassage =  performance.user.user_save.passage - 3;
            dayWidth = (18 * (dayPassage - 1)/4) + "%";
        } else if  ( performance.user.user_save.passage > 6 &&  performance.user.user_save.passage <= 10){
            dayNumber = 4;
            dayPassage =  performance.user.user_save.passage - 6;
            dayWidth = (18 * (dayPassage - 1)/4) + "%";
        } else if  ( performance.user.user_save.passage > 10 &&  performance.user.user_save.passage <= 12){
            dayNumber = 5;
            dayPassage =  performance.user.user_save.passage - 10;
            dayWidth = (18 * (dayPassage - 1)/4) + "%";
        } else if  ( performance.user.user_save.passage > 12 &&  performance.user.user_save.passage <= 15){
            dayNumber = 6;
            dayPassage =  performance.user.user_save.passage - 12;
            dayWidth = (18 * (dayPassage - 1)/4) + "%";
        } else if  ( performance.user.user_save.passage > 15){
            dayNumber = 7;
            dayPassage =  performance.user.user_save.passage - 15;
            dayWidth =  "100%";
        }

        if (!(performance.user.user_save && performance.user.user_save.passage)){
            montyWidth = "calc(20% * "+dayNumber+" + "+dayWidth+ " + " +trainingCampWidth + " - 10px)";
            montyPosition = "0%";
            positionWidth = "0px";
        } else if(isTrainingCamp && performance.user.user_save.passage <= 1){
            montyWidth = "calc(20% * "+dayNumber+" + "+dayWidth+ " + " +trainingCampWidth + " - 10px)";
            montyPosition = "calc(20% * "+dayNumber+" + 1%)";
            positionWidth = "calc("+dayWidth+" + " +trainingCampWidth + ")";
        } else if(dayNumber == 5){
            montyWidth = "88%";
            montyPosition = "81%";
            positionWidth = "17%";
        }else{
            montyWidth = 19  +  (dayNumber-1)*(56/3) +(dayPassage-1)*(13/3)+ "%";
            montyPosition = "calc(20% * "+dayNumber+" + 1%)";
            positionWidth = "calc("+dayWidth+" + " +trainingCampWidth + " + 3.5%)";
        }


        let studentKnowledgeWidth =  Math.round( Number(this.state.studentKnowledge) * 100) + "%";
        let studentMonitoringWidth = Math.round(Number(this.state.studentMonitoring) * 100) + "%";
        let studentMainIdeaWidth = Math.round(Number(this.state.studentMainIdea) * 100) + "%";
        let studentMomentOfTruthWidth = Math.round(Number(this.state.studentMomentOfTruth) * 100) + "%";

        return (
            <div className={"student-performance-box"} style={{height:550 }}>
                <div className={"row"}>
                    <div className={'col-md-6 '}>
                        <div htmlFor="inputClassName">
                            {this.props.role?<h3>{performance.user.firstname+" "+ performance.user.lastname} </h3>:
                            <h2>{performance.user.firstname+" "+ performance.user.lastname} </h2>}

                        </div>
                    </div>
                    <div className={'col-md-0 '}>

                        <Modal isOpen={this.state.isOpened} style={customStyle}>
                            <PerformanceListItem role={this.props.role} performance={this.props.performance} handleClosed={ this.handleClosed }/>
                        </Modal>
                    </div>
                    <div className={'col-md-6'} style={{textAlign:"right"}}>
                        <div > LAST ACCESSED: {performance.user.user_save && performance.user.user_save.updatedAt ? performance.user.user_save.updatedAt.substring(0, 10):"No Record"} </div>

                        <div > Game Score: {performance.user.user_save && performance.user.user_save.score?performance.user.user_save.score:"0"} </div>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={'col-md-5'} style={{textAlign:'center'}}>
                        <h4>Mission 1<hr/></h4>
                    </div>
                    <div className={'col-md-3'} style={{textAlign:'center'}}>
                        <h4>Mission 2<hr/></h4>
                    </div>
                    <div className={'col-md-3'} style={{textAlign:'center', marginLeft:20}}>
                        <h4>Mission 3<hr/></h4>
                    </div>
                </div>
                <div className={"row"} style={this.props.role?{marginLeft:0}:{marginLeft:10}} >
                    <SiteStatusBox role={this.props.role} siteNumber={1} sitesStatus={performance.user.user_save.site} currentSite={dayNumber} currentPassage={dayPassage}/>
                    <SiteStatusBox role={this.props.role} siteNumber={2} sitesStatus={performance.user.user_save.site} currentSite={dayNumber} currentPassage={dayPassage}/>
                    <SiteStatusBox role={this.props.role} siteNumber={3} sitesStatus={performance.user.user_save.site} currentSite={dayNumber} currentPassage={dayPassage}/>
                    <SiteStatusBox role={this.props.role} siteNumber={4} sitesStatus={performance.user.user_save.site} currentSite={dayNumber} currentPassage={dayPassage}/>
                    <SiteStatusBox role={this.props.role} siteNumber={5} sitesStatus={performance.user.user_save.site} currentSite={dayNumber} currentPassage={dayPassage}/>
                    <SiteStatusBox role={this.props.role} siteNumber={6} sitesStatus={performance.user.user_save.site} currentSite={dayNumber} currentPassage={dayPassage}/>
                    <SiteStatusBox role={this.props.role} siteNumber={7} sitesStatus={performance.user.user_save.site} currentSite={dayNumber} currentPassage={dayPassage}/>
                </div>
                <div className="col-lg-12 solidBorder hasfitWidth" style={this.props.role?{marginTop:20}:{marginTop:0}}><DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />

                    <div className={"row"}>

                        <hr/>
                        <div style={{marginTop: -10}}> <h3> SKILLS</h3></div>
                        <div className={'progress-bar-block'} style={{marginTop: -5}}> knowledge </div>
                        <div className={'progress-stripes'} > </div>
                        {this.state.studentKnowledge?
                            <div className={Math.round(this.state.studentKnowledge * 100)<40? 'progress-gradient gradient-red':Math.round(this.state.studentKnowledge * 100)<80?'progress-gradient gradient-yellow':'progress-gradient gradient-green'} style={{width:studentKnowledgeWidth}}> {studentKnowledgeWidth} </div> : <div className={' gradient-null'} style={{width:10}}>0%</div> }
                        <div className={'progress-bar-block clearfix'} style={{marginTop: -5}}> Monitoring </div>
                        <div className={'progress-stripes'} > </div>
                        {this.state.studentMonitoring?
                            <div className={Math.round(this.state.studentMonitoring * 100)<40? 'progress-gradient gradient-red':Math.round(this.state.studentMonitoring * 100)<80?'progress-gradient gradient-yellow':'progress-gradient gradient-green'} style={{width:studentMonitoringWidth }}> {studentMonitoringWidth} </div> : <div className={' gradient-null'} style={{width:10}}>0%</div> }
                        <div className={'progress-bar-block clearfix'} style={{marginTop: -5}}> Main Idea </div>
                        <div className={'progress-stripes'} > </div>
                        {this.state.studentMainIdea?
                            <div className={Math.round(this.state.studentMainIdea * 100)<40? 'progress-gradient gradient-red':Math.round(this.state.studentMainIdea * 100)<80?'progress-gradient gradient-yellow':'progress-gradient gradient-green'} style={{width:studentMainIdeaWidth}}> {studentMainIdeaWidth} </div> : <div className={' gradient-null'} style={{width:10}}>0%</div> }
                        <div className={'progress-bar-block clearfix'} style={{marginTop: -5, }}> Moment of Truth </div>
                        <div className={'progress-stripes'} > </div>
                        {this.state.studentMomentOfTruth?
                            <div className={Math.round(this.state.studentMomentOfTruth * 100)<40? 'progress-gradient gradient-red':Math.round(this.state.studentMomentOfTruth * 100)<80?'progress-gradient gradient-yellow':'progress-gradient gradient-green'} style={{width:studentMomentOfTruthWidth}}> {studentMomentOfTruthWidth} </div> : <div className={' gradient-null'} style={{width:10}}>0%</div> }
                    </div>

                </div>

            </div>






        )
    }
}
class SiteStatusBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            passageNumber:0,
            siteNumber:this.props.siteNumber,
            siteStatus:'',
            totalPassage:0,
            siteTitle:'',
            siteIcon:'',
            backColor:'',
            margin:0,

        }
    }

    componentDidMount(){
        let totalPassage = 0;
        let siteTitle='';
        let siteIcon='';
        let backgroundColor = '';
        let marginLeft =0;
        switch(this.props.siteNumber){
            case 1:
                totalPassage=2;
                siteTitle='Civet';
                siteIcon = icon_teacher_cici;
                backgroundColor = '#6bd66b';
                break;
            case 2:
                totalPassage=1;
                siteTitle='Monkey';
                siteIcon = icon_teacher_monkey;
                backgroundColor = '#6bd66b';
                break;
            case 3:
                totalPassage=3;
                siteTitle='Shrew';
                siteIcon = icon_teacher_rincho;
                backgroundColor = '#6bd66b';
                break;
            case 4:
                totalPassage=4;
                siteTitle='Rhino';
                siteIcon = icon_teacher_didi;
                backgroundColor = '#dacf6e';
                marginLeft =10;
                break;
            case 5:
                totalPassage=2;
                siteTitle='Giraffe';
                siteIcon = icon_teacher_giraffe;
                backgroundColor = '#dacf6e';
                marginLeft =10;
                break;
            case 6:
                totalPassage=3;
                siteTitle='Dugong';
                siteIcon = icon_teacher_doug;
                backgroundColor = '#70ccdc';
                marginLeft =20;
                break;
            case 7:
                totalPassage=3;
                siteTitle='EagleRay';
                siteIcon = icon_teacher_myla;
                backgroundColor = '#70ccdc';
                marginLeft =20;
                break;

        }

        this.setState({
            totalPassage:totalPassage,
            siteTitle:siteTitle,
            siteIcon:siteIcon,
            margin:marginLeft,
            backColor: backgroundColor,
        });


        if(this.props.sitesStatus&&this.props.sitesStatus.substring(this.props.siteNumber-1,this.props.siteNumber)=='1') {
            this.setState({
                siteStatus:'  Completed',
                backColor:'#6bd66b'
            });
            let passageNumber = 0;
            switch(this.props.siteNumber){
                case 1:
                    passageNumber=2;
                    break;
                case 2:
                    passageNumber=1;
                    break;
                case 3:
                    passageNumber=3;
                    break;
                case 4:
                    passageNumber=4;
                    break;
                case 5:
                    passageNumber=2;
                    break;
                case 6:
                    passageNumber=3;
                    break;
                case 7:
                    passageNumber=3;
                    break;

            }
            this.setState({
                passageNumber:passageNumber
            });

        }
        else if(this.props.currentSite!==this.props.siteNumber){
            this.setState({
                passageNumber:0,
                siteStatus:'Not Yet Started',
                backColor:'lightGray',

            });
        } else{
            this.setState({
                passageNumber:this.props.currentPassage,
                siteStatus:'  In Progress',
                backColor:'#dacf6e',

            });
        }

    }
    render() {
        return (

            <div className={"row"} style={this.props.role?{float:'left',width:95,height:120}:{float:'left',width:130}}>
                <div className={'col-md-12'}>
                    <div className={'col-md-12 student-site-box'} style={this.props.role?{backgroundColor:this.state.backColor,height:130, marginLeft:this.state.margin}:{backgroundColor:this.state.backColor, marginLeft:this.state.margin}}>
                        <div style={this.props.role?{marginLeft: 0,marginTop: -15}:{marginLeft: 10,marginTop: -15}}>
                            {this.props.role?<div style={{marginTop:5}}>{this.state.siteTitle}</div>
                                :<h4>{this.state.siteTitle}</h4>}
                        </div>
                        <div>
                            <div  style={this.props.role?{marginLeft:-8,marginTop: 5}:{marginLeft: 10,marginTop: 5}}>
                                <img src={this.state.siteIcon} style={{width:60, height:60}}/>
                            </div>
                        </div>
                        <div  style={this.props.role?{marginLeft:10,marginTop:5}:{marginLeft:30,marginTop:5}}>
                            <h4>{this.state.passageNumber}/{this.state.totalPassage}</h4>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}


class PerformanceListItem extends Component {
    constructor(props){
        super(props);
        this.state = {
            currentBadge : this.props.performance && this.props.performance.badges && this.props.performance.badges[1]? this.props.performance.badges[1]: null ,
            folded: true,
            currentProgress : {
                knowledge : 0,
                monitoring : 0,
                mainIdea : 0,
                momentOfTruth: 0,
            },
            currentDay: 1,
        }
        this.handleClick = this.handleClick.bind(this);
        this.handleBadgeChange = this.handleBadgeChange.bind(this);
        this.handleFolded = this.handleFolded.bind(this);
        this.handleClosed = this.handleClosed.bind(this);
        this.getCurrentProgress = this.getCurrentProgress.bind(this);
    }
    getCurrentProgress( progress, day, type){
        let value = 0;
        let score = 0;
        let maxScore = 0;
        if(day == 1 && type == "knowledge"){
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["1-1"]?  progress.progress_knowledge_score["1-1"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["1-2"]?  progress.progress_knowledge_score["1-2"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["1-3"]?  progress.progress_knowledge_score["1-3"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["1-4"]?  progress.progress_knowledge_score["1-4"]:0;

            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["1-1"]?  progress.progress_knowledge_max["1-1"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["1-2"]?  progress.progress_knowledge_max["1-2"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["1-3"]?  progress.progress_knowledge_max["1-3"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["1-4"]?  progress.progress_knowledge_max["1-4"]:0;
        }
        else if(day == 1 && type == "monitoring") {
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["1-1"] ? progress.progress_monitoring_score["1-1"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["1-2"] ? progress.progress_monitoring_score["1-2"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["1-3"] ? progress.progress_monitoring_score["1-3"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["1-4"] ? progress.progress_monitoring_score["1-4"] : 0;

            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["1-1"] ? progress.progress_monitoring_max["1-1"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["1-2"] ? progress.progress_monitoring_max["1-2"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["1-3"] ? progress.progress_monitoring_max["1-3"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["1-4"] ? progress.progress_monitoring_max["1-4"] : 0;
        }
        else if(day == 1 && type == "mainIdea") {
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["1-1"] ? progress.progress_mainIdea_score["1-1"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["1-2"] ? progress.progress_mainIdea_score["1-2"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["1-3"] ? progress.progress_mainIdea_score["1-3"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["1-4"] ? progress.progress_mainIdea_score["1-4"] : 0;

            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["1-1"] ? progress.progress_mainIdea_max["1-1"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["1-2"] ? progress.progress_mainIdea_max["1-2"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["1-3"] ? progress.progress_mainIdea_max["1-3"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["1-4"] ? progress.progress_mainIdea_max["1-4"] : 0;
        }
        else if(day == 1 && type == "momentOfTruth") {
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["1-1"] ? progress.progress_momentOfTruth_score["1-1"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["1-2"] ? progress.progress_momentOfTruth_score["1-2"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["1-3"] ? progress.progress_momentOfTruth_score["1-3"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["1-4"] ? progress.progress_momentOfTruth_score["1-4"] : 0;

            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["1-1"] ? progress.progress_momentOfTruth_max["1-1"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["1-2"] ? progress.progress_momentOfTruth_max["1-2"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["1-3"] ? progress.progress_momentOfTruth_max["1-3"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["1-4"] ? progress.progress_momentOfTruth_max["1-4"] : 0;
        }

        else if(day == 2 && type == "knowledge"){
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["2-5"]?  progress.progress_knowledge_score["2-5"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["2-6"]?  progress.progress_knowledge_score["2-6"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["2-7"]?  progress.progress_knowledge_score["2-7"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["2-8"]?  progress.progress_knowledge_score["2-8"]:0;

            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["2-5"]?  progress.progress_knowledge_max["2-5"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["2-6"]?  progress.progress_knowledge_max["2-6"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["2-7"]?  progress.progress_knowledge_max["2-7"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["2-8"]?  progress.progress_knowledge_max["2-8"]:0;
        }
        else if(day == 2 && type == "monitoring") {
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["2-5"] ? progress.progress_monitoring_score["2-5"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["2-6"] ? progress.progress_monitoring_score["2-6"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["2-7"] ? progress.progress_monitoring_score["2-7"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["2-8"] ? progress.progress_monitoring_score["2-8"] : 0;

            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["2-5"] ? progress.progress_monitoring_max["2-5"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["2-6"] ? progress.progress_monitoring_max["2-6"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["2-7"] ? progress.progress_monitoring_max["2-7"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["2-8"] ? progress.progress_monitoring_max["2-8"] : 0;
        }
        else if(day == 2 && type == "mainIdea") {
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["2-5"] ? progress.progress_mainIdea_score["2-5"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["2-6"] ? progress.progress_mainIdea_score["2-6"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["2-7"] ? progress.progress_mainIdea_score["2-7"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["2-8"] ? progress.progress_mainIdea_score["2-8"] : 0;

            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["2-5"] ? progress.progress_mainIdea_max["2-5"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["2-6"] ? progress.progress_mainIdea_max["2-6"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["2-7"] ? progress.progress_mainIdea_max["2-7"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["2-8"] ? progress.progress_mainIdea_max["2-8"] : 0;
        }
        else if(day == 2 && type == "momentOfTruth") {
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["2-5"] ? progress.progress_momentOfTruth_score["2-5"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["2-6"] ? progress.progress_momentOfTruth_score["2-6"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["2-7"] ? progress.progress_momentOfTruth_score["2-7"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["2-8"] ? progress.progress_momentOfTruth_score["2-8"] : 0;

            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["2-5"] ? progress.progress_momentOfTruth_max["2-5"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["2-6"] ? progress.progress_momentOfTruth_max["2-6"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["2-7"] ? progress.progress_momentOfTruth_max["2-7"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["2-8"] ? progress.progress_momentOfTruth_max["2-8"] : 0;
        }
        else if(day == 3 && type == "knowledge"){
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["3-9"]?  progress.progress_knowledge_score["3-9"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["3-10"]?  progress.progress_knowledge_score["3-10"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["3-11"]?  progress.progress_knowledge_score["3-11"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["3-12"]?  progress.progress_knowledge_score["3-12"]:0;

            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["3-9"]?  progress.progress_knowledge_max["3-9"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["3-10"]?  progress.progress_knowledge_max["3-10"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["3-11"]?  progress.progress_knowledge_max["3-11"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["3-12"]?  progress.progress_knowledge_max["3-12"]:0;
        }
        else if(day == 3 && type == "monitoring") {
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["3-9"] ? progress.progress_monitoring_score["3-9"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["3-10"] ? progress.progress_monitoring_score["3-10"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["3-11"] ? progress.progress_monitoring_score["3-11"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["3-12"] ? progress.progress_monitoring_score["3-12"] : 0;

            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["3-9"] ? progress.progress_monitoring_max["3-9"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["3-10"] ? progress.progress_monitoring_max["3-10"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["3-11"] ? progress.progress_monitoring_max["3-11"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["3-12"] ? progress.progress_monitoring_max["3-12"] : 0;
        }
        else if(day == 3 && type == "mainIdea") {
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["3-9"] ? progress.progress_mainIdea_score["3-9"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["3-10"] ? progress.progress_mainIdea_score["3-10"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["3-11"] ? progress.progress_mainIdea_score["3-11"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["3-12"] ? progress.progress_mainIdea_score["3-12"] : 0;

            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["3-9"] ? progress.progress_mainIdea_max["3-9"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["3-10"] ? progress.progress_mainIdea_max["3-10"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["3-11"] ? progress.progress_mainIdea_max["3-11"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["3-12"] ? progress.progress_mainIdea_max["3-12"] : 0;
        }
        else if(day == 3 && type == "momentOfTruth") {
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["3-9"] ? progress.progress_momentOfTruth_score["3-9"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["3-10"] ? progress.progress_momentOfTruth_score["3-10"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["3-11"] ? progress.progress_momentOfTruth_score["3-11"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["3-12"] ? progress.progress_momentOfTruth_score["3-12"] : 0;

            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["3-9"] ? progress.progress_momentOfTruth_max["3-9"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["3-10"] ? progress.progress_momentOfTruth_max["3-10"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["3-11"] ? progress.progress_momentOfTruth_max["3-11"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["3-12"] ? progress.progress_momentOfTruth_max["3-12"] : 0;
        }
        else if(day == 4 && type == "knowledge"){
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["4-13"]?  progress.progress_knowledge_score["4-13"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["4-14"]?  progress.progress_knowledge_score["4-14"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["4-15"]?  progress.progress_knowledge_score["4-15"]:0;
            score += progress && progress.progress_knowledge_score && progress.progress_knowledge_score["4-16"]?  progress.progress_knowledge_score["4-16"]:0;

            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["4-13"]?  progress.progress_knowledge_max["4-13"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["4-14"]?  progress.progress_knowledge_max["4-14"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["4-15"]?  progress.progress_knowledge_max["4-15"]:0;
            maxScore += progress && progress.progress_knowledge_max && progress.progress_knowledge_max["4-16"]?  progress.progress_knowledge_max["4-16"]:0;
        }
        else if(day == 4 && type == "monitoring") {
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["4-13"] ? progress.progress_monitoring_score["4-13"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["4-14"] ? progress.progress_monitoring_score["4-14"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["4-15"] ? progress.progress_monitoring_score["4-15"] : 0;
            score += progress && progress.progress_monitoring_score && progress.progress_monitoring_score["4-16"] ? progress.progress_monitoring_score["4-16"] : 0;

            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["4-13"] ? progress.progress_monitoring_max["4-13"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["4-14"] ? progress.progress_monitoring_max["4-14"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["4-15"] ? progress.progress_monitoring_max["4-15"] : 0;
            maxScore += progress && progress.progress_monitoring_max && progress.progress_monitoring_max["4-16"] ? progress.progress_monitoring_max["4-16"] : 0;
        }
        else if(day == 4 && type == "mainIdea") {
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["4-13"] ? progress.progress_mainIdea_score["4-13"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["4-14"] ? progress.progress_mainIdea_score["4-14"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["4-15"] ? progress.progress_mainIdea_score["4-15"] : 0;
            score += progress && progress.progress_mainIdea_score && progress.progress_mainIdea_score["4-16"] ? progress.progress_mainIdea_score["4-16"] : 0;

            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["4-13"] ? progress.progress_mainIdea_max["4-13"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["4-14"] ? progress.progress_mainIdea_max["4-14"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["4-15"] ? progress.progress_mainIdea_max["4-15"] : 0;
            maxScore += progress && progress.progress_mainIdea_max && progress.progress_mainIdea_max["4-16"] ? progress.progress_mainIdea_max["4-16"] : 0;
        }
        else if(day == 4 && type == "momentOfTruth") {
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["4-13"] ? progress.progress_momentOfTruth_score["4-13"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["4-14"] ? progress.progress_momentOfTruth_score["4-14"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["4-15"] ? progress.progress_momentOfTruth_score["4-15"] : 0;
            score += progress && progress.progress_momentOfTruth_score && progress.progress_momentOfTruth_score["4-16"] ? progress.progress_momentOfTruth_score["4-16"] : 0;

            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["4-13"] ? progress.progress_momentOfTruth_max["4-13"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["4-14"] ? progress.progress_momentOfTruth_max["4-14"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["4-15"] ? progress.progress_momentOfTruth_max["4-15"] : 0;
            maxScore += progress && progress.progress_momentOfTruth_max && progress.progress_momentOfTruth_max["4-16"] ? progress.progress_momentOfTruth_max["4-16"] : 0;
        }
        if(maxScore!=0){
            value = score/maxScore;
            value = value.toFixed(2);
        }
        return value;
    }
    componentDidMount(){
        this.setState({
            currentBadge: this.props.performance && this.props.performance.badges && this.props.performance.badges[1]? this.props.performance.badges[1]: null,
            currentProgress: {
                knowledge : this.getCurrentProgress(this.props.performance.progress,this.state.currentDay,"knowledge"),
                monitoring : this.getCurrentProgress(this.props.performance.progress,this.state.currentDay,"monitoring"),
                mainIdea : this.getCurrentProgress(this.props.performance.progress,this.state.currentDay,"mainIdea"),
                momentOfTruth: this.getCurrentProgress(this.props.performance.progress,this.state.currentDay,"momentOfTruth"),
            }
        })
    }

    componentDidUpdate(oldProps){
        const newProps = this.props;
        if(oldProps.performance.id !== newProps.performance.id) {
            this.setState({
                currentBadge: this.props.performance && this.props.performance.badges && this.props.performance.badges[1] ? this.props.performance.badges[1] : null,
                currentProgress: {
                    knowledge : this.getCurrentProgress(this.props.performance.progress,this.state.currentDay,"knowledge"),
                    monitoring : this.getCurrentProgress(this.props.performance.progress,this.state.currentDay,"monitoring"),
                    mainIdea : this.getCurrentProgress(this.props.performance.progress,this.state.currentDay,"mainIdea"),
                    momentOfTruth: this.getCurrentProgress(this.props.performance.progress,this.state.currentDay,"momentOfTruth")
                }
            })
        }
    }
    handleFolded() {
        this.setState({folded : !this.state.folded});
    }
    handleClosed() {
        this.props.handleClosed();
    }
    handleClick(event) {
        this.props.handleClick(this.props.student);
        event.stopPropagation();
    }
    async handleBadgeChange(event) {
        await this.setState({
            currentDay: event.value,
            currentBadge: this.props.performance.badges[event.value],
            currentProgress: {
                knowledge : this.getCurrentProgress(this.props.performance.progress,event.value,"knowledge"),
                monitoring : this.getCurrentProgress(this.props.performance.progress,event.value,"monitoring"),
                mainIdea : this.getCurrentProgress(this.props.performance.progress,event.value,"mainIdea"),
                momentOfTruth: this.getCurrentProgress(this.props.performance.progress,event.value,"momentOfTruth"),
            }
        })
    }


    render() {
        let student = this.props.student;
        let performance = this.props.performance;
        let dayNumber;
        let dayPassage;
        let dayWidth;
        let montyWidth;
        let montyPosition;
        let positionWidth;
        let isTrainingCamp = false;
        let trainingCampWidth="0%";
        let knowledgeWidth = "0%;"
        let monitoringWidth = "0%;";
        let mainIdeaWidth = "0%;";
        let momentOfTruthWidth = "0%;";
        let knowledgeBadge = this.state.currentBadge && this.state.currentBadge.knowledge?this.state.currentBadge.knowledge: null;
        let monitoringBadge = this.state.currentBadge && this.state.currentBadge.monitoring?this.state.currentBadge.monitoring:null;
        let mainIdeaBadge = this.state.currentBadge && this.state.currentBadge.mainIdea?this.state.currentBadge.mainIdea:null;
        let momentOfTruthBadge = this.state.currentBadge && this.state.currentBadge.momentOfTruth?this.state.currentBadge.momentOfTruth:null;
        knowledgeBadge = knowledgeBadge ? knowledgeBadge.charAt(0).toUpperCase() +  knowledgeBadge.slice(1): null;
        monitoringBadge = monitoringBadge ? monitoringBadge.charAt(0).toUpperCase() +  monitoringBadge.slice(1): null;
        mainIdeaBadge = mainIdeaBadge ? mainIdeaBadge.charAt(0).toUpperCase() +  mainIdeaBadge.slice(1): null;
        momentOfTruthBadge = momentOfTruthBadge ? momentOfTruthBadge.charAt(0).toUpperCase() +  momentOfTruthBadge.slice(1): null;
        if(!performance.user.user_save){
            performance.user.user_save = {};
            performance.user.user_save.trainingCamp = "0";
            performance.user.user_save.dayTransition = "0";
        }

        knowledgeWidth =  (23 * this.state.currentProgress.knowledge) + "%";
        monitoringWidth = (23 * this.state.currentProgress.monitoring) + "%";
        mainIdeaWidth = (23 * this.state.currentProgress.mainIdea) + "%";
        momentOfTruthWidth = (23 * this.state.currentProgress.momentOfTruth) + "%";

        if(!performance.user.user_save) {
            dayNumber = 0;
            dayPassage = 0;
            dayWidth = 0;
            isTrainingCamp = true;
            trainingCampWidth="2%";
        }else if(performance.user.user_save.trainingCamp < 5 && performance.user.user_save && performance.user.user_save.passage <= 1){
            dayNumber = 0;
            dayWidth = (17 * performance.user.user_save.trainingCamp /5)  + "%";
            trainingCampWidth="2%";
            isTrainingCamp = true;

        } else if ( performance.user.user_save.passage <= 4){
            dayNumber = 1;
            dayPassage =  performance.user.user_save.passage;
            dayWidth = (18 * (dayPassage-1) /4) + "%";
        } else if ( performance.user.user_save.passage > 4 &&  performance.user.user_save.passage <= 8){
            dayNumber = 2;
            dayPassage =  performance.user.user_save.passage - 4;
            dayWidth = (18 * (dayPassage - 1)/4) + "%";
        } else if  ( performance.user.user_save.passage > 8 &&  performance.user.user_save.passage <= 12){
            dayNumber = 3;
            dayPassage =  performance.user.user_save.passage - 8;
            dayWidth = (18 * (dayPassage - 1)/4) + "%";
        } else if  ( performance.user.user_save.passage > 12 &&  performance.user.user_save.passage <= 16){
            dayNumber = 4;
            dayPassage =  performance.user.user_save.passage - 12;
            dayWidth = (18 * (dayPassage - 1)/4) + "%";
        } else if  ( performance.user.user_save.passage > 16){
            dayNumber = 5;
            dayPassage =  4;
            dayWidth =  "100%";
        }

        if (!(performance.user.user_save && performance.user.user_save.passage)){
            montyWidth = "calc(20% * "+dayNumber+" + "+dayWidth+ " + " +trainingCampWidth + " - 10px)";
            montyPosition = "0%";
            positionWidth = "0px";
        } else if(isTrainingCamp && performance.user.user_save.passage <= 1){
            montyWidth = "calc(20% * "+dayNumber+" + "+dayWidth+ " + " +trainingCampWidth + " - 10px)";
            montyPosition = "calc(20% * "+dayNumber+" + 1%)";
            positionWidth = "calc("+dayWidth+" + " +trainingCampWidth + ")";
        } else if(dayNumber == 5){
            montyWidth = "88%";
            montyPosition = "81%";
            positionWidth = "17%";
        }else{
            montyWidth = 19  +  (dayNumber-1)*(56/3) +(dayPassage-1)*(13/3)+ "%";
            montyPosition = "calc(20% * "+dayNumber+" + 1%)";
            positionWidth = "calc("+dayWidth+" + " +trainingCampWidth + " + 3.5%)";
        }

        return (
            <div className={"student-performance-box"} style={{ height:700 }}>
                <div className={"row"}>
                    <div className={'col-md-5 '}>
                        <div htmlFor="inputClassName"><h2>{performance.user.firstname+" "+ performance.user.lastname} </h2> </div>
                    </div>
                    <div className={'"modal-footer"'}>
                        <a onClick={this.handleClosed} className="handBtn"><span>Close</span></a>
                    </div>
                    <div className={'col-md-6'} style={{textAlign:"right"}}>
                        <div > LAST ACCESSED: {performance.user.user_save && performance.user.user_save.updatedAt ? performance.user.user_save.updatedAt.substring(0, 10):"No Record"} </div>

                        <div > Game Score: {performance.user.user_save && performance.user.user_save.score?performance.user.user_save.score:"0"} </div>
                    </div>
                </div>

                <hr/>


                <div style={{marginTop: 20}}> <h3> Game Progress</h3> </div>
                <div className={"row"}>
                    <div className={'progress-bar-block'}> Training Camp </div>
                    <div className={'progress-bar-block'}> Day 1 </div>
                    <div className={'progress-bar-block'}> Day 2 </div>
                    <div className={'progress-bar-block'}> Day 3 </div>
                    <div className={'progress-bar-block'}> Day 4 </div>
                </div>

                <div className={"row"}>
                    <div className={dayNumber>0?'  gameProgress-gradient gradient-blue':'  gameProgress-gradient light-grey'} > </div>
                    <div className={dayNumber>1?' stripes light-blue':' stripes light-grey'}> </div>

                    <div className={dayNumber>2?'  stripes light-blue':' stripes light-grey'} > </div>

                    <div className={dayNumber>3?' stripes light-blue':' stripes light-grey'} > </div>
                    <div className={dayNumber>4?'  stripes light-blue':' stripes light-grey'} style={{borderTopRightRadius:10,borderBottomRightRadius:10 }}> </div>
                </div>
                <div className={"row"}>
                    <div style={{float: "left", marginTop: -39, marginLeft: montyWidth , zIndex:100, position:"absolute"}} ><img src={icon_monty}  border="0" /></div>
                    <div className={'stripes'} style={{marginLeft: montyPosition, width: positionWidth, height: 30, backgroundColor:"#9ccadc", marginTop: -37,}}> </div>
                </div>

                <div className={"row"} style={{marginTop:15, display:'none'}}>
                    <div style={{textAlign:"right", marginLeft: 50,float: "left",marginTop: 5}}> Off Campus Progress </div>
                    <div  style={{border:"solid", borderWidth: 1,padding: 3, width:130,float: "left",marginLeft:10 }}>
                        <img src={performance.user.user_save.dayTransition >= 1? icon_finished : icon_unfinished}  style={{}}  border="0"  />
                        <img src={performance.user.user_save.dayTransition >= 2? icon_finished : icon_unfinished}  style={{}}  border="0"  />
                        <img src={performance.user.user_save.dayTransition >= 3? icon_finished : icon_unfinished}  style={{}}  border="0"  />
                        <img src={performance.user.user_save.dayTransition >= 4? icon_finished : icon_unfinished}  style={{}}  border="0"  />
                    </div>
                    <div  style={{border:"solid", borderWidth: 1,padding: 3,width:130,float: "left"}}>
                        <img src={performance.user.user_save.dayTransition >= 11? icon_finished : icon_unfinished}  style={{}}  border="0"  />
                        <img src={performance.user.user_save.dayTransition >= 12? icon_finished : icon_unfinished}  style={{}}  border="0"  />
                        <img src={performance.user.user_save.dayTransition >= 13? icon_finished : icon_unfinished}  style={{}}  border="0"  />
                        <img src={performance.user.user_save.dayTransition >= 14? icon_finished : icon_unfinished}  style={{}}  border="0"  />
                    </div>
                    <div  style={{border:"solid", borderWidth: 1,padding: 3,width:95,float: "left"}}>
                        <img src={performance.user.user_save.dayTransition >= 21? icon_finished : icon_unfinished}  style={{}}  border="0"  />
                        <img src={performance.user.user_save.dayTransition >= 22? icon_finished : icon_unfinished}  style={{}}  border="0"  />
                        <img src={performance.user.user_save.dayTransition >= 23? icon_finished : icon_unfinished}  style={{}}  border="0"  />
                    </div>

                </div>
                <div style={{marginTop:15}} > <h3> Passage Progress </h3> </div>
                <div className={"row"} style={{marginTop:-10}}>
                    <div className={'progress-bar-block-passage'} > Knowledge </div>
                    <div className={'progress-bar-block-passage'} > Monitoring </div>
                    <div className={'progress-bar-block-passage'} > Main Idea </div>
                    <div className={'progress-bar-block-passage'} > Moment of Truth </div>
                </div>
                <div className={"row"}style={{marginTop:-10}}>
                    <div className={'progress-stripes-passage'}  > </div>
                    <div className={'progress-stripes-passage'} > </div>
                    <div className={'progress-stripes-passage'} > </div>
                    <div className={'progress-stripes-passage'} > </div>

                </div>
                <div className={"row"} >
                    {this.state.currentProgress.knowledge?
                        <div className={Math.round(this.state.currentProgress.knowledge * 100)<40? 'progress-gradient gradient-red':Math.round(this.state.currentProgress.knowledge * 100)<80?'progress-gradient gradient-yellow':'progress-gradient gradient-green'} style={{width: knowledgeWidth,marginTop:-28,marginLeft:"1%"}} >
                            { Math.round(this.state.currentProgress.knowledge * 100)+"%"}
                        </div>:
                        <div className={' gradient-null'} style={{width:10,marginTop:-27.5,marginLeft:"1%"}}>
                            0%
                        </div>
                    }
                    {this.state.currentProgress.monitoring?
                        <div className={Math.round(this.state.currentProgress.monitoring * 100)<40? 'progress-gradient gradient-red':Math.round(this.state.currentProgress.monitoring * 100)<80?'progress-gradient gradient-yellow':'progress-gradient gradient-green'} style={{width:monitoringWidth,marginTop:-28,marginLeft:"26%"}}>
                            {Math.round(this.state.currentProgress.monitoring  * 100)+"%"}
                        </div>:
                        <div className={' gradient-null'} style={{width:10,marginTop:-27.5,marginLeft:"26%"}}>
                            0%
                        </div>}
                    {this.state.currentProgress.mainIdea?
                        <div className={Math.round(this.state.currentProgress.mainIdea * 100)<40? 'progress-gradient gradient-red':Math.round(this.state.currentProgress.mainIdea * 100)<80?'progress-gradient gradient-yellow':'progress-gradient gradient-green'} style={{width:mainIdeaWidth,marginTop:-28,marginLeft:"51%"}}>
                            {Math.round(this.state.currentProgress.mainIdea  * 100)+"%"}
                        </div>:
                        <div className={' gradient-null'} style={{width:10,marginTop:-27.5,marginLeft:"51%"}}>
                            0%
                        </div>}
                    {this.state.currentProgress.momentOfTruth?
                        <div className={Math.round(this.state.currentProgress.momentOfTruth * 100)<40? 'progress-gradient gradient-red':Math.round(this.state.currentProgress.momentOfTruth * 100)<80?'progress-gradient gradient-yellow':'progress-gradient gradient-green'} style={{width:momentOfTruthWidth,marginTop:-28,marginLeft:"76%"}}>
                            {Math.round(this.state.currentProgress.momentOfTruth  * 100)+"%"}
                        </div> :
                        <div className={' gradient-null'} style={{width:10,marginTop:-27.5,marginLeft:"76%"}}>
                            0%
                        </div>}
                </div>
                <div style={{marginTop:15}} > <h3> Hypothesis Selected </h3> </div>
                <div className={"row"}>
                    <div className={'col-md-3 '}> Cause of Sickness: </div>
                    <div className={'col-md-3 '} style={{backgroundColor:"lightgrey", width: 150, borderRadius:10 , textAlign: "center"}} >  {performance.hypothesis}  </div>
                </div>
                <div style={{marginTop:15}} > <h3> Badges </h3> </div>
                <div className={"row"}>
                    <div className={'col-md-3 '}>
                        <Select options={dayOptions} defaultValue={{value:"1", label:"Day 1"}}  isSearchable={false} onChange = {this.handleBadgeChange} />

                    </div>
                    <div className={'col-md-2 '}>
                        < BadgeItem type = "Knowledge" level = {knowledgeBadge }/>
                    </div>
                    <div className={'col-md-2 '}>
                        < BadgeItem type = "Monitoring" level = {monitoringBadge  }/>
                    </div>
                    <div className={'col-md-2 '}>
                        < BadgeItem type = "Main Idea" level = {mainIdeaBadge  }/>
                    </div>
                    <div className={'col-md-2 '}>
                        < BadgeItem type = "Moment of Truth" level = {momentOfTruthBadge  }/>
                    </div>



                </div>
            </div>


        )
    }
}
class BadgeItem extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let icon;
        if(this.props.level && this.props.type == "Knowledge" && this.props.level == "Diamond" ){
            icon = icon_knowledge_diamond;
        }
        else if (this.props.level&&this.props.type == "Knowledge" && this.props.level == "Gold"){
            icon = icon_knowledge_gold;
        }
        else if (this.props.level &&this.props.type == "Knowledge" && this.props.level == "Silver"){
            icon = icon_knowledge_silver;
        }
        else if (this.props.level &&this.props.type == "Knowledge" && this.props.level == "Bronze"){
            icon = icon_knowledge_bronze;
        }
        else if (this.props.level &&this.props.type == "Monitoring" && this.props.level == "Bronze"){
            icon = icon_monitoring_bronze;
        }
        else if (this.props.level &&this.props.type == "Monitoring" && this.props.level == "Silver"){
            icon = icon_monitoring_silver;
        }
        else if (this.props.level &&this.props.type == "Monitoring" && this.props.level == "Gold"){
            icon = icon_monitoring_gold;
        }
        else if (this.props.level &&this.props.type == "Monitoring" && this.props.level == "Diamond"){
            icon = icon_monitoring_diamond;
        }
        else if (this.props.level &&this.props.type == "Moment of Truth" && this.props.level == "Bronze"){
            icon = icon_MomentOfTruth_bronze;
        }
        else if (this.props.level &&this.props.type == "Moment of Truth" && this.props.level == "Silver"){
            icon = icon_MomentOfTruth_silver;
        }
        else if (this.props.level &&this.props.type == "Moment of Truth" && this.props.level == "Gold"){
            icon = icon_MomentOfTruth_gold;
        }
        else if (this.props.level &&this.props.type == "Moment of Truth" && this.props.level == "Diamond"){
            icon = icon_MomentOfTruth_diamond;
        }
        else if (this.props.level &&this.props.type == "Main Idea" && this.props.level == "Bronze"){
            icon = icon_MainIdea_bronze;
        }
        else if (this.props.level &&this.props.type == "Main Idea" && this.props.level == "Silver"){
            icon = icon_MainIdea_silver;
        }
        else if (this.props.level &&this.props.type == "Main Idea" && this.props.level == "Gold"){
            icon = icon_MainIdea_gold;
        }
        else if (this.props.level &&this.props.type == "Main Idea" && this.props.level == "Diamond"){
            icon = icon_MainIdea_diamond;
        }
        return (


            <div >{this.props.level?
                <div>
                    <div>
                        <img src={icon}  style={{}}  border="0"  />
                    </div>
                    <div style = {{textAlign: "center", height: 50}} > {this.props.type} </div>
                    <div style={{marginTop:-5, textAlign: "center"}} > {this.props.level} </div>
                </div>
                : null}
            </div>

        )
    }
}
export class ClassListComponent extends Component {

    handleItemClick = (object) => {
        this.props.handleItemClick(object);
    };

    render() {
        let items = this.props.classes;
        const classes = items.map((item) => {
            return <ClassItemComponent key={item.id} item={item} active={this.props.clickedClassID===item.id ? "active":""} handleClick={this.handleItemClick} deleteClass={this.props.deleteClass}/>
        });
        return (
            <table cellPadding="0" cellSpacing="0" border="0" width="100%">
                <tbody>
                {classes}
                </tbody>
            </table>
        );
    }
}

class ClassItemComponent extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.deleteClass = this.deleteClass.bind(this);
    }

    handleClick(event) {
        this.props.handleClick(this.props.item);
        event.preventDefault();
    }

    deleteClass(event){
        let confirmed = window.confirm("Are you sure that you want to delete this class ?");
        if(confirmed) {
            this.props.deleteClass(this.props.item);
        }
        event.stopPropagation();
    }

    render() {
        return (
            <tr className={"clickable-row "+this.props.active} onClick={this.handleClick}>
                <td>{this.props.item.name}</td>
                <td className="fitWidth">
                    <a>
                        <img src={ico_view} alt="View Icon" border="0" className="ico-xs" />
                    </a>
                </td>
                {/*<td>*/}
                {/*<input*/}
                {/*onClick={(e)=>this.deleteClass(e)}*/}
                {/*style={{maxHeight:25}}*/}
                {/*type="image"*/}
                {/*alt={"Delete"}*/}
                {/*src={require("../assets/images/ico-trash.png")}*/}
                {/*/>*/}
                {/*</td>*/}
            </tr>
        );
    }
}

const bindActionToProps = dispatch => {
    return {
        selectClass: async(selectedClass) => await dispatch(selectClass(selectedClass)),
        updateStudent: async(selectedStudent) => await dispatch(updateStudent(selectedStudent)),
        updateTeacher: async(data) => await dispatch(updateTeacher(data)),
        userLogout: async() => await dispatch(userLogout())
    };
};


const mapStateToProps = state => ({
    lastClass: state.teacherReducer.lastClass,
    lastStudent: state.teacherReducer.student,
    teacher: state.teacherReducer.teacher
});


export default connect(mapStateToProps,bindActionToProps)(withRouter(MainTeacherComponent));
